<template>
  <div class="terms">
    <div>
      <!-- eslint-disable vue/no-bare-strings-in-template -->
      <template v-if="locale !== 'de' || companyStore.isEEI">
        <p />
        <p v-if="companyStore.isCombinator">The governing law of the following Terms & Conditions are the laws of the country of Switzerland.</p>
        <p v-if="companyStore.isEFC">
          The following terms and conditions apply under the laws of the Swiss Confederation. IP or license notice (“The content made available
          on this website, in particular films, images and texts, as well as the ERSTIES brand) are protected by intellectual property rights and
          are used by EFC GmbH, Pfäfikon (CH) on the basis of a license.”)
        </p>

        <h1 v-if="companyStore.isEFC" id="legal">LEGAL:</h1>
        <h1 v-else id="legal">2257 NOTICE / LEGAL:</h1>
        <template v-if="!companyStore.isEFC">
          <p>
            All models, actors, actresses and other persons that appear in any visual portrayal of actual sexually explicit conduct appearing or
            otherwise contained in this Website were over the age of eighteen years at the time the visual image was created.
          </p>
          <p>
            All other visual depictions displayed on this Website are exempt from the provision of 18 U.S.C. section 2257 and 28 C.F.R. 75
            because said they do not portray conduct as specifically listed in 18 U.S.C section 2256 (2) (A) through (D), but are merely
            depictions of non-sexually explicit nudity, or are depictions of simulated sexual conduct, or are otherwise exempt because the visual
            depictions were created prior to March 1 2009.
          </p>
          <p>
            With respect to all visual depictions displayed on this web site, whether of actual sexually explicit conduct, simulated sexual
            conduct or otherwise, all persons were at least 18 years of age when said visual depictions were created.
          </p>
          <p>All records, including all model's proof of age,required to be kept by federal law are held by the Custodian of Records.</p>
          <p />
          <p>Custodian of Records:</p>
          <p>
            <imprint :show-financial="false" :show-title="false" />
          </p>
        </template>
        <div class="legal-definitions">
          <p><b>1. Legal definitions</b></p>
          <p>
            "Member" or "Membership," as referred to in this document, means: The subscriber or User of a valid username and password (User ID)
            for the site during the term of membership.
          </p>
          <p>
            "Site" or "The Website," as referred to in this document, means: https://www.ersties.{{ tld }}, and any other site within the
            "ersties.{{ tld }}" group of sites. The sites are owned and operated by
            <imprint :show-financial="false" :show-title="false" />
          </p>
          <p>
            "The Service," as referred to in this document, means: the duration of the Subscription, including access to materials on the
            Website.
          </p>
          <p>
            "Subscriber," as referred to in this document, means: The end user or consumer, of the services of the site and holder of a valid
            username and password (User ID) for the site.
          </p>
          <p>
            "User ID," as referred to in this document, means: The combination of unique username and password that is sold by Ersties.{{ tld }}
            and used to access the site. A user-id is a license to use the site for a period of time that is specified.
          </p>
          <p>
            "Bookmarking," as referred to in is document, means: The act of placing a URL into a temporary file on the subscriber's browser so
            that the subscriber may return to that page at a future date directly, without passing through other pages.
          </p>
          <p>
            "Billing Provider," as referred to in is document, means: the Company or Service by which a person transfers funds to ersties.{{
              tld
            }}
            for access to ersties.{{ tld }}
          </p>
          <p><b>2. Description of services </b></p>
          <p>The Website will provide one User ID and password to access the Website when you purchase a membership.</p>
          <p><b>3. Payment / Fee</b></p>
          <p>
            The Website has periodic subscription fees that are defined by the Website at the time of the initial subscription purchase. The
            member is responsible for all fees incurred. Once a member has accessed the site using the assigned User ID, subscription fees become
            non-refundable.
          </p>
          <p>Payment will be via one of the Website's chosen billing providers.</p>
          <p><b>4. Automatic Recurring Billing </b></p>
          <p>Some accounts may Rebill on a schedule as indicated on the initial join page.</p>
          <p>Rebilling must be cancelled by Member seven (7) days prior to renewal.</p>
          <p>The maximum Term of this agreement is 100 months.</p>
          <p>
            Unless and until this agreement is cancelled in accordance with the terms hereof, subscriber hereby authorises Ersties.{{ tld }}'s
            billing agent to charge subscriber's credit card to pay for the ongoing cost of membership.
          </p>
          <p><b>5. Electronic Receipt</b></p>
          <p>
            Member will receive a receipt by email, sent within one hour of subscription being approved. It is the duty of the subscriber to
            maintain this receipt for the duration of the subscription. It will be required should any queries need to be addressed by the
            Website or its billing provider.
          </p>
          <p><b>6. Cancellation</b></p>
          <p v-if="!companyStore.isEEI">
            At any time, and without reason, subscription to the service may be terminated by the website or the subscriber upon notifying the
            other party by electronic or conventional mail or directly by approaching <a href="https://epoch.com" rel="nofollow">Epoch.com</a> or
            <a href="https://cs.segpay.com" rel="nofollow">Segpayeu.com</a>, depending on which payment provider processed the billing. When the
            Subscriber requests the termination, subscription fees are NOT refunded.
          </p>
          <p v-else>
            At any time, and without cause, subscription to the Service may be terminated by the Website, or the subscriber upon notification of
            the other by electronic or conventional mail. When the Subscriber requests the termination, subscription fees are NOT refunded.
          </p>
          <p>
            It is the duty of the subscriber to ensure that the Subscriber receives an email from the Website's billing provider confirming the
            cancellation of the Subscription. The cancellation process is not complete until the Subscriber has received this email, and acted
            upon the instructions within it if applicable.
          </p>
          <p><b>7. Refunds</b></p>
          <p>Our refund policy is simple, and applies under the following conditions:</p>
          <ul>
            <li>
              If you find we have misled you in any way (for example, we promise something in our free area that does not exist in our members
              area), we'll give you a refund.
            </li>
            <li>
              If your computer setup is of our minimum specs, and a significant portion does not work (you need to prove it!), we'll give you a
              refund.
            </li>
            <li>
              If our site is down for a significant portion of your subscription, we'll either extend your sub for double the time the site was
              down for, or give you a refund.
            </li>
            <li>
              If we supply something that is damaged or does not work and if you allow us reasonable time to fix the problem with your help,
              we'll give you a refund.
            </li>
          </ul>
          <p><b>8. Bookmarking</b></p>
          <p>
            Subscriber agrees that at any time they will not bookmark any page to the site that will allow the subscriber to bypass the terms and
            conditions of the site upon entering. If such a bookmark exists, said bookmark will constitute full agreement to said terms and
            conditions as well as to admission that subscriber is of legal age of majority in their state, country or region.
          </p>
          <p><b>9. Authorization of Use </b></p>
          <p>
            Subscribers to the site are hereby authorized a single license to download material found on the site. This license shall be granted
            for their private use only. All memberships are provided for personal use and shall not be used for any commercial purposes or by any
            commercial entities without the express authorization of ersties.{{ tld }}.
          </p>
          <p>
            Commercial use of either the site or any material found within is strictly prohibited. No material within the site may be transferred
            to any other person or entity, whether commercial or non-commercial. In addition, materials may not be modified, or altered.
            Materials may not be displayed publicly, or used for any rental, sale, or display.
          </p>
          <p>
            Authorization shall extend to copyright, trademarks, or other proprietary notice. Ersties.{{ tld }} reserves the right to terminate
            this license at any time if the terms of this agreement are breached. In the case that the terms are breached, you will be required
            to immediately destroy any information or material printed, downloaded or otherwise copied from the site.
          </p>
          <p><b>10. Unacceptable Abuse of Site</b></p>
          <p>
            We prohibit the use of "spiders", site scrapers, quad suckers, and any programs similar in operation to gather bulk material from our
            site. Upon detection, subscribers who unreasonably and excessively download will have their accounts cancelled without refund.
          </p>
          <p v-if="companyStore.isEFC">
            <b>11. Transfer of User-id and Subscriptions</b>
          </p>
          <p v-else>
            <b>11. Transfer of User-id </b>
          </p>
          <p>
            Access to the site is through a combination of a username and a password (User ID). Subscribers may not under any circumstances
            release their User ID to any other person, and are required to keep his or her User ID strictly confidential. ersties.{{ tld }} will
            not release passwords for any reason, to anyone other than the subscriber at the email address used when initially subscribing,
            except as may be specifically required by law or court order.
          </p>
          <p>
            Unauthorised access to the site is a breach of this Agreement and a violation of law. Subscribers acknowledge that the site will
            track, through the use of special software, each subscriber's entry to the site by logging of IP address assigned by the Subscribers'
            Internet Service Provider.
          </p>
          <p>
            If any breach of security, theft or loss of a User ID, or unauthorized disclosure of a User ID occurs, subscriber must immediately
            notify ersties.{{ tld }}
            of said security breach. The Subscriber will remain liable for unauthorized use of service until the site is notified of the security
            breach by email, and confirmation of notification is received by the Subscriber. This notification is deemed complete ONLY when the
            Subscriber has received confirmation of notification.
          </p>
          <p v-if="companyStore.isEFC">
            Ersties is entitled to transfer all rights and obligations arising from terms of use and the contractual relationship with the
            subscriber to an affiliate or any other third party.
          </p>
          <p><b>12. Sanction and Approval of Adult Material</b></p>
          <p>
            ersties.{{ tld }} is designed to be used and viewed solely by Subscribers who are of legal age in their province, state or locality,
            and who wish to access visual images, audio sounds, descriptions of a sexually oriented and frankly erotic nature.
          </p>
          <p>
            Materials available within this site may include depictions that are visually graphic in nature and portrayals of nudity or sexual
            acts and should not be accessed be anyone who is not of legal age in their province, state or locality, by anyone who finds such
            material offensive in nature, or by anyone who simply does not wish to be exposed to such materials.
          </p>
          <p>By purchasing a Subscription, you are implicitly making the following statements:</p>
          <p>
            "I swear or affirm, under penalty of Perjury, that I am of legal age in my province, state or locality. I will not permit any persons
            under the legal age in my province, state or locality to view or access in any way any materials found on this website.
          </p>
          <p>
            "I understand that by accessing this website, I will be exposed to materials that may include but are not limited to, visual images,
            audio sounds, and descriptions of a sexually oriented and frankly erotic nature, portrayals of nudity, and sexual acts.
          </p>
          <p>"I affirm that I am not offended by such materials, and that such materials are legal in my community.</p>
          <p>
            "I certify that I wish to view, hear, and access such materials voluntarily, and I choose to do so because I want to view/read/hear
            or otherwise access such aterials for my own enjoyment, information or entertainment. My choice is a manifestation of my interest in
            such matters.
          </p>
          <p>
            "I am completely familiar with the standards held in my community, and the material I expect to access in this site fall within these
            standards. In my experience, the average adult in my community accepts the consumption of such materials by willing adults in
            circumstances such as this, which offer reasonable insulation from the materials for minors, and unwilling adults. Adults in my
            community will accept the standards displayed within this site, and will not find any of the material patently offensive."
          </p>
          <template v-if="showAgeVerificationText">
            <p>
              We may require you to complete an age verification process using an approved verification method or trusted third-party provider.
              If you cannot successfully complete age verification, access to restricted services may be limited or withdrawn.
            </p>
            <p><b>Refunds in Case of Failed Age Verification</b></p>
            <p>
              If age verification cannot be completed for any reason, including refusal to provide information or inability to meet the
              requirements, no refunds will be issued for payments already made. Please ensure you meet the applicable age requirement before
              making a purchase or subscription.
            </p>
          </template>
          <p><b>13. Severability </b></p>
          <p>
            If any provision of this Agreement shall be held to be invalid or unenforceable for any reason, the remaining provisions shall
            continue to be valid and enforceable. If a court finds that any of this Agreement is invalid or unenforceable, but that by limiting
            such provision it would become valid or enforceable, then such provision shall be deemed to be written, construed, and enforced as so
            limited.
          </p>
          <p><b>14. Notice </b></p>
          <p>
            Notices by the site to subscribers will be given by means of electronic messages through the site, or by a general posting on the
            site. It is the responsibility of the Subscriber to regularly check the email address specified upon joining of the website, to keep
            the website appraised of email address changes, and to ensure the email address supplied is kept operational and free from any event
            that might cause "bouncing".
          </p>
          <p>
            If the Subscribers email address becomes invalid, the Subscriber agrees to hold ersties.{{ tld }} harmless for any expenses incurred
            on a Subscriber's account (for example, rebilling when a cancellation notice goes un-received by the Subscriber).
          </p>
          <p>
            Notices by Subscriber may only be given by email. All questions, complaints, or notices regarding the site or the Billing Provider
            may be directed to the Billing Provider or ersties.{{ tld }}. Cancellations of service to the site may be directed to the Billing
            Provider or ersties.{{ tld }}.
          </p>
          <p>
            This policy is subject to change, and such changes are effective without notice. Ersties.co may publicize notice of change to this
            Notice at its discretion.
          </p>
          <template v-if="companyStore.isEEI">
            <p><b>15. Final Provision</b></p>
            <p>Arizona law is applicable to US customers</p>
          </template>
        </div>

        <h1 id="privacy_policy">Privacy Policy of ERSTIES {{ tld === "net" ? ".NET" : "" }}</h1>
        <p>
          Hereinafter we inform you about the nature, scope and purpose of the processing of your personal data when using our website and online
          content. Personal data is any information that relates to an identified or identifiable natural person. The person responsible
          (“controller”) within the meaning of the EU General Data Protection Regulation (GDPR) is the natural or legal person which, alone or
          jointly with others, determines the purposes and means of the processing of personal data. The controller within the meaning of the
          GDPR for the personal data processed by the provider of this website and online service is:
        </p>

        <p v-if="companyStore.isEEI">info (@) ersties.com</p>
        <imprint v-else :show-title="false" />
        <p>&nbsp;</p>

        <p><b>Using our onlineservice or website</b></p>
        <p>
          When you visit our website, our server collects the following information from you: browser type and version, operating system used,
          the previously visited web page, IP address and time of the page view. From your IP address, we can not identify you in person. We also
          do not match your IP address with other data in such a way that such inference would be possible.
        </p>
        <p>
          We collect and process this data in order to ensure the trouble-free operation of our website and to detect, fend off and prosecute a
          misuse of our services. Furthermore, we use the collected data for statistical purposes to evaluate, for example, with which terminals
          and browsers our platform is accessed in order to adapt our offer on the basis of the needs of users on an ongoing basis and to
          improve.
        </p>
        <p>
          This data processing is based on Article 6 par. 1 f GDPR. We will delete the aforementioned data no later than six months after it has
          been collected.
        </p>

        <p>&nbsp;</p>
        <p><b>Customer Account</b></p>
        <p>
          You also have the option to create a customer account on our website. The mandatory information required for this will be communicated
          to you in the entry mask and the entered data will be used for the purpose of using our service. We provide you with information
          relevant to the service or registration, such as changes in our offer or technical circumstances by e-mail. If you delete your customer
          account, your data will be deleted from the customer account, unless their storage is necessary for commercial or tax reasons (Art. 6
          par. 1 c GDPR). It is your responsibility to back up your data before deleting your customer account. We are entitled to irretrievably
          delete all of your data stored during the term of the contract.
        </p>
        <p v-if="companyStore.isEFC">
          When registering and using the customer account, the IP address and the time of your respective use will be saved. The storage is based
          on our legitimate interests, as well as your interest in protection against misuse and other unauthorized use. A transfer of these data
          to third parties does not take place, unless it is necessary for the prosecution of our claims or there is a legal obligation in
          accordance with Art. 6 par. 1 c GDPR or unless the operation of our website and your customer account will be transferred to a
          different operating company. The IP addresses will be anonymized or deleted after 7 days at the latest.
        </p>
        <p v-else>
          When registering and using the customer account, the IP address and the time of your respective use will be saved. The storage is based
          on our legitimate interests, as well as your interest in protection against misuse and other unauthorized use. A transfer of these data
          to third parties does not take place, unless it is necessary for the prosecution of our claims or there is a legal obligation in
          accordance with Art. 6 par. 1 c GDPR. The IP addresses will be anonymized or deleted after 7 days at the latest.
        </p>
        <p>
          If you make use of the services offered on our site, we store the data you entered during the ordering process. This includes, in
          particular, your name, address, e-mail address, and other information voluntarily provided by you (such as a different delivery address
          or telephone number). We process this data electronically for the proper performance of the contract, in particular for the fulfillment
          of our contractual services, invoicing, accounting, and processing of complaints. This data processing is based on Article 6 par. 1 b
          GDPR. We store this data until all mutual claims arising from the respective contractual relationship with you have been completely
          settled and the commercial and fiscal retention periods to which we are subject have expired.
        </p>
        <p>
          To conclude a contract between you and us, it is necessary that we receive your name, e-mail address and address. The necessity of
          providing this data arises, among other things, from various legal regulations. Without providing this data, you cannot conclude a
          contract with us.
        </p>
        <p>We do not use any automated decision-making or profiling.</p>

        <p>&nbsp;</p>
        <p><b>Payment</b></p>
        <p>
          If you use a payment method provided by Epoch (Epoch.{{ tld }}, LLC, 2644 30th St FL 2, Santa Monica, California 90405, USA), Epoch
          collects and processes your name, card or bank account number, and/or, if applicable, further data required for processing the chosen
          payment method. For this purpose, Epoch`s Privacy Policy applies additionally (https://www.epoch.com/privacy.html).
        </p>

        <p>&nbsp;</p>
        <p><b>Contact</b></p>
        <p>
          If you send us a message via the contact function on your website, we will process your personal data entered (your name and e-mail
          address) along with your message (legal basis: Article 6 par. 1 a GDPR). If you send us a message by e-mail, we will save your message
          along with the sender details (your name and e-mail address) in order to be able to answer it and also to respond to possible
          subsequent questions (legal basis: Article 6 par. 1 f GDPR). For the reception, storage and sending of e-mails, we use an e-mail
          provider who acts for us as a processor in accordance with Article 28 GDPR. We will erase the information collected from your message
          no later than six months after the last communication with you.
        </p>
        <p>
          If you send us a message with information legally relevant for the contractual relationship (e.g. a withdrawal or a complaint), the
          legal basis for the processing is Article 6 par. 1 b GDPR, regardless of how you transmitted your message to us. In such a case, we
          will erase the data related to your message as soon as all mutual claims arising from the contractual relationship have been completely
          settled and the commercial and fiscal retention periods have expired.
        </p>

        <p>&nbsp;</p>
        <p><b>Newsletter</b></p>
        <p>
          Hereinafter we inform you about the contents of our newsletter as well as the registration procedure and its dispatch, as well as your
          right of objection. By subscribing to our newsletter, you agree to the receipt and the procedures described.
        </p>
        <p>
          We send you newsletters by e-mail only with your consent (legal basis: Art. 6 (1) lit. a, Art. 7 GDPR). Before subscribing to the
          newsletter, you will be informed about its contents and your consent only applies to these contents. Our newsletters contain
          information about our services and us.
        </p>
        <p>
          After signing up for our newsletter, you will receive an e-mail asking you to confirm your registration and given data. This
          confirmation e-mail is used by us to prove whether the owner of the e-mail address as the data subject has authorized to receive the
          newsletter. Registration for the newsletter will be logged in order to prove your consent and a lawful registration process. For this
          purpose, your IP address will be stored at the time of the registration and its confirmation (legal basis: Art. 6 par. 1 lit. a GDPR).
          To subscribe to the newsletter we need your e-mail address. If you wish to be addressed personally in the newsletter, you can also
          optionally provide your name.
        </p>
        <p>
          The cancellation of the newsletter – i.e. the revocation of your consent - is possible at any time. At the end of each newsletter email
          you will find a link to unsubscribe. In order to prove your original consent, we may store your signing-up data for up to three years
          based on our legitimate interests.
        </p>

        <p>&nbsp;</p>
        <p><b>Social Media</b></p>
        <p>
          You may find Social Media Buttons on your website; they can be recognized by the logos of the social media platforms (hereinafter
          “platforms”) (Facebook: blue “f”, Google Plus: red “g+”, Pinterest: red “p”, Twitter: blue bird silhouette). These are links to the
          respective platforms based in the United States (USA). Clicking on such a link calls the respective Platform’s website; at the same
          time, the IP address of your device and the address of the page where the link is placed (“Referrer”) will be transmitted to the
          Platform in the USA. However, we neither collect nor otherwise process any data related to the use of these social media buttons.
        </p>

        <p>&nbsp;</p>
        <p><b>Cookies</b></p>
        <p>
          We use cookies on our site. These are small files that your browser automatically creates and that are stored on your device (laptop,
          tablet, smartphone, etc.) when you visit our site.
        </p>
        <p>
          In the cookie information is stored, each resulting in connection with the specific device used. However, this does not mean that we
          are immediately aware of your identity.
        </p>
        <p>
          On the one hand, the use of cookies serves to make the use of our offer more pleasant for you. For example, we use so-called session
          cookies to recognize that you have already visited individual pages on our website. These are automatically deleted after leaving our
          page.
        </p>
        <p>
          In addition, to improve usability, we also use temporary cookies that are stored on your device for a specific period of time. If you
          visit our site again to take advantage of our services, you will automatically be notified that you have already been with us and what
          inputs and settings you have made so that you do not have to enter them again.
        </p>
        <p>
          On the other hand, we use cookies in order to statistically record the use of our website and to evaluate it for the purpose of
          optimizing our offer. These cookies enable us to automatically recognize when you visit our site again that you have already visited
          us. These cookies are automatically deleted after a defined time.
        </p>
        <p>
          The data processed by means of cookies are for the stated purposes in order to safeguard our legitimate interests as well as the third
          party according to Art. 6 para. 1 1 lit. f GDPR required.
        </p>
        <p>
          Most browsers accept cookies automatically. However, you can configure your browser so that no cookies are stored on your computer or
          that a warning always appears before a new cookie is created. However, disabling cookies completely may mean that you can not use all
          features of our website.
        </p>

        <p>&nbsp;</p>
        <p><b>Transfers to third countries</b></p>
        <p>
          If we process data in a third country (i.e. outside the European Union (EU) or the European Economic Area (EEA)) or if this occurs in
          the context of the use of third-party services or disclosure or transfer of data to third parties, this only takes place if it occurs
          for the fulfilment of our (pre)contractual obligations, on the basis of your consent, on the basis of a legal obligation or on the
          basis of our legitimate interests. We will only process your data in a third country if this is legally or contractually permitted
          under the special conditions of Arts. 44 et seq. GDPR. Thus, the processing is carried out, for example, on the basis of special
          guarantees, such as the officially recognised determination of a data protection level corresponding to the EU (e.g. for the USA
          through the "Privacy Shield") or compliance with legally recognised standard contractual clauses.
        </p>

        <p>&nbsp;</p>
        <p><b>Mixpanel</b></p>
        <p>
          As part of the range analysis of Mixpanel based on our legitimate interests (ie interest in the analysis, optimization and economic
          operation of our online offer within the meaning of Art. 6 para 1 lit. f GDPR) processed the following data: the browser type you use
          and the browser version, the operating system you are using, your country of origin, the date and time of the server request, the
          number of visits, how long you have spent on the site, and the external links you have activated. The IP address of the users is
          anonymized before being saved. Mixpanel uses cookies.
        </p>
        <p>
          Mixpanel is certified under the Privacy Shield Agreement, which provides a guarantee to comply with European privacy legislation
          (https://www.privacyshield.gov/participant?id=a2zt0000000TOacAAG&status=Active).
        </p>
        <p>
          The information generated by the cookie about your use of this online offer is stored on a server in the USA. Here, user profiles of
          the users can be created from the processed data, these being used only for analysis and not for advertising purposes. For more
          information, see the Mixpanel Privacy Policy: https://mixpanel.com/legal/privacy-policy/
        </p>

        <p>&nbsp;</p>
        <p><b>Integration of third-party services</b></p>
        <p>
          Within our online offer, we make no representations or warranties of any kind based on our legitimate interests (i.e. interest in the
          analysis, optimisation and economic operation of our online offer within the meaning of Art. 6 par. 1 lit. f. GDPR) content or service
          offerings from third parties to include content and services such as videos or fonts. The respective third party provider must receive
          the IP address of the user, as he cannot send the contents to the user's browser without the IP address. The IP address is therefore
          required for the display of this content. We make every effort to use only those contents whose respective providers use the IP address
          only for the delivery of the contents.
        </p>

        <p>&nbsp;</p>
        <p><b>Data security</b></p>
        <p>
          We use the SSL procedure (Secure Socket Layer) within our website in conjunction with the highest enctryption level, which is used by
          your browser. Usually this is a 256 bit encryption. Whether an individual pages of our web content offer a encrypted transfer can be
          recognized by the depiction of a closed key or key lock symbol in the status bar of your browser.
        </p>
        <p>
          We use appropriate technical and organisational security measures to protect your data against accidental or wilfull manipulation,
          partial or total loss, distruction or against unauthorised access by third parties. In doing so, we try to continuously improve our
          security measures and adapt them to technical developments.
        </p>

        <p>&nbsp;</p>
        <p><b>Your Rights</b></p>
        <p>With regard to your personal data we process, you have the following rights:</p>
        <p>
          a) You have the right to obtain a confirmation from us as to whether we process personal data concerning you. If this is the case, we
          will inform you about the personal data stored about you and the further information in accordance with Article 15 par. 1 and 2 GDPR.
        </p>
        <p>
          b) You have the right to have your inaccurate personal data rectified without undue delay. Taking into account the purposes of
          processing, you also have the right to request the completion of incomplete personal data, including by means of providing a
          supplementary statement.
        </p>
        <p>
          c) You can demand the erasure of your personal data concerning you under the conditions of Article 17 par. 1 GDPR without undue delay,
          as far as their processing is not necessary according to Article 17 par. 3 GDPR.
        </p>
        <p>
          d) You may demand that we restrict the processing of your data if one of the requirements of Article 18 par. 1 GDPR applies. In
          particular, you can request the restriction instead of an erasure.
        </p>
        <p>
          e) We will communicate any rectification or erasure of your personal data and a restriction of processing to all recipients to whom we
          have disclosed your personal data, unless this proves impossible or involves a disproportionate effort. We will also inform you about
          these recipients if you request it.
        </p>
        <p>
          f) You have the right to receive the personal data which you provide to us in a structured, commonly used and machine-readable format.
          You may also request that we transmit the data to another controller without hindrance, where technically feasible.
        </p>
        <p>
          g) As far as a data processing is based on your given consent, you have the right to, withdraw your consent at any time. The withdrawal
          of consent shall not affect the lawfulness of the data processing based on consent before its withdrawal.
        </p>

        <p>&nbsp;</p>
        <p>
          <b
            >RIGHT TO OBJECT: ON GROUNDS RELATING TO YOUR PARTICULAR SITUATION, YOU MAY, AT ANY TIME, OBJECT TO PROCESSING OF YOUR PERSONAL DATA;
            this right applies to a processing, according to Article 6 par. 1 f DPRG, necessary for the purposes of the legitimate interests
            pursued by us or by a third party, except where such interests are overridden by your interests or fundamental rights and freedoms of
            the data subject which require protection of personal data, in particular where the data subject is a child.
          </b>
        </p>
        <p>
          <b
            >If you exercise your right to object, we will no longer process the personal data in question unless we can demonstrate compelling
            legitimate grounds for processing that override the interests, rights and freedoms of you, or for the establishment, exercise or
            defense of legal claims.
          </b>
        </p>

        <p>&nbsp;</p>
        <p>
          <b
            >IN CASE WE PROCESS PERSONAL DATA FOR DIRECT MARKETING PURPOSES (E.G. NEWSLETTER), YOU MAY, AT ANY TIME, OBJECT TO PROCESSING OF YOUR
            PERSONAL DATA FOR THE PURPOSE OF SUCH ADVERTISING, WITH THE RESULT THAT WE WILL NO LONGER PROCESS YOUR DATA FOR THESE PURPOSES.
          </b>
        </p>

        <p>&nbsp;</p>
        <p>
          If you believe that the processing of your personal data is in breach of the GDPR, you may lodge a complaint with a supervisory
          authority, in particular in the Member State of your habitual residence, place of work or place of the alleged infringement. This does
          not exclude other administrative or judicial remedies.
        </p>

        <p>&nbsp;</p>
        <p><b>Up-to-dateness and change of this Privacy Policy</b></p>
        <p>This privacy policy is currently valid as of May 2018.</p>
        <p>
          Due to the further development of our website and our offers thereof or due to changed legal or regulatory requirements, it may be
          necessary to change this privacy policy. The current privacy policy can be viewed and printed by you at any time on the website at
          <b>https://ersties.{{ tld }}/agb#privacy_policy.</b>
        </p>

        <template v-if="companyStore.isEFC">
          <h1 id="notice">2257 NOTICE</h1>
          <p>
            All models, actors, actresses and other persons that appear in any visual portrayal of actual sexually explicit conduct appearing or
            otherwise contained in this Website were over the age of eighteen years at the time the visual image was created.
          </p>
          <p>
            All other visual depictions displayed on this Website are exempt from the provision of 18 U.S.C. section 2257 and 28 C.F.R. 75
            because said they do not portray conduct as specifically listed in 18 U.S.C section 2256 (2) (A) through (D), but are merely
            depictions of non-sexually explicit nudity, or are depictions of simulated sexual conduct, or are otherwise exempt because the visual
            depictions were created prior to March 1 2009.
          </p>
          <p>
            With respect to all visual depictions displayed on this web site, whether of actual sexually explicit conduct, simulated sexual
            conduct or otherwise, all persons were at least 18 years of age when said visual depictions were created.
          </p>
          <p>All records, including all model's proof of age,required to be kept by federal law are held by the Custodian of Records.</p>
          <p>Custodian of Records:</p>
          <p class="custodian-records">
            Reichenberger Strasse 124<br />
            10999 Berlin<br />
            Germany
          </p>

          <p>Please direct legal questions pertaining to this website to 2257inquiries@ersties-custodian.com</p>
        </template>
      </template>
      <template v-else>
        <p id="legal" />
        <p>
          Die folgenden AGBs gelten nach dem Recht der Schweizerischen Eidgenossenschaft.
          <template v-if="companyStore.isEFC">
            IP- bzw. Lizenzhinweis ("Die auf dieser Website zugänglich gemachten Inhalte, insb. Filme, Bilder und Texte, sowie die Marke ERSTIES)
            sind immaterialgüterrechtlich geschützt und werden von der EFC GmbH, Pfäffikon (CH), auf Basis einer Lizenz genutzt.")
          </template>
        </p>
        <h1>Allgemeine Geschäftsbedingungen:</h1>

        <p>
          1. ANBIETER/GELTUNGSBER&shy;EICH/KONVENTIALSTRAFE/
          <wbr />
          LEISTUNGEN/ NUTZER /MITGLIEDSCHAFT
        </p>

        <p>1.1.)</p>

        <p>
          Der Anbieter und Vertragspartner für auf der Webseite www.ersties.com dargestellten Inhalte und Leistungen ist die
          <template v-if="companyStore.isCombinator"> Combinator AG, Samstagernstrasse 55, 8832 Wollerau </template>
          <template v-else> EFC GmbH, Sonnenhof 3, 8808 Pfäffikon </template>
          , E-Mail info (@ )ersties.com (im folgenden „Anbieter“).
        </p>

        <p>
          Die vorliegenden allgemeinen Geschäftsbedingungen sind Bestandteil jeglicher vertraglichen Vereinbarungen mit dem jeweiligen Nutzer.
        </p>

        <p>1.2.)</p>

        <p>
          Geplante Änderungen der AGB und beabsichtigtes Inkrafttreten (frühestens nach Ablauf nachstehender Widerspruchsfrist) werden dem Kunden
          per Brief oder Email mitgeteilt; der Kunde kann dagegen binnen 5 Wochen, gerechnet ab Eingang beim Kunden, per Brief oder Email
          (Kontaktdaten siehe 5.2.) Widerspruch einlegen. Geht innerhalb dieser Frist keine entsprechende Erklärung des Kunden beim Anbieter ein,
          gilt dies als Zustimmung. Die geänderten AGB werden in diesem Fall mit jenem Tag wirksam („Änderungstermin“), welcher dem Kunden vorab
          mitgeteilt wurde. Der Anbieter wird den Kunden in seiner Mitteilung nach Satz 1 auf genannte Frist und Bedeutung seines Verhaltens
          (Widerspruch bzw. Schweigen) hinweisen. Im Falle eines rechtzeitigen Widerspruchs des Kunden treten die geplanten Änderungen der AGB in
          Bezug auf diesen Kunden nicht in Kraft. Gegenüber diesem Kunden gelten die ursprünglich von ihm akzeptierten AGB. Der Anbieter behält
          sich vor, dass Vertragsverhältnis im Falle eines Widerspruchs zu kündigen.
        </p>

        <p>1.3.) Vertragsstrafe:</p>

        <p>
          Für den Fall schuldhafter Verletzungen von Pflichten dieser Allgemeinen Geschäftsbedingungen vereinbaren Anbieter und Kunde eine von
          dem Kunden zu zahlende Vertragsstrafe in Höhe von EUR 500,00 pro Verstoß. Sollte es nach dem ersten schuldhaften Verstoß gegen diese
          AGB zu weiteren schuldhaften Verstößen gegen diese AGB kommen, die trotz Abmahnung durch den Anbieter per Brief oder Email nicht
          abgestellt werden, kann der Anbieter eine maximale Vertragsstrafe in Höhe von EUR 1.500,00 von dem Kunden verlangen. Dem Kunden bleibt
          nachgelassen nachzuweisen, dass dem Anbieter ein geringerer Schaden entstanden ist. Die Konventionalstrafe wird jedoch erst fällig,
          wenn diese dem anderen Vertragspartner gegenüber schriftlich geltend gemacht wird.
        </p>

        <p>1.4.)</p>

        <p>
          Der Anbieter unterhält ein Portal für erotische Unterhaltungsdienstleistungen. Insbesondere stellt das Portal Bilder und Videos mit
          erotischen Inhalten zur Verfügung.
        </p>

        <p>1.5.)</p>

        <p>
          Der Zugriff auf diese Inhalte setzt den Abschluss eines entgeltlichen Vertrags (im folgenden „Mitgliedschaft“) zwischen Anbieter und
          Nutzer voraus. Alternativ kann ein Nutzer durch Abschluss eines unentgeltlichen Vertrags (im Folgenden „kostenlose Mitgliedschaft“)
          Zugang zu einem eingeschränkten Teil des Angebots erhalten.
        </p>

        <p>1.6.)</p>

        <p>
          Alle Modelle, die auf Fotos, Film oder Livecam auf Ersties.com oder jeglichem anderem Angebot der
          <template v-if="companyStore.isCombinator"> Combinator AG </template>
          <template v-else> EFC GmbH </template>
          dargestellt werden, sind volljährig. Nachweise zur Volljährigkeit zum Zeitpunkt der Entstehung des oben genannten Materials werden von
          uns gesondert aufbewahrt und stehen dem jeweiligen Gesetzgeber oder Partner jederzeit zur Prüfung, auf Anfrage, zur Verfügung.
        </p>

        <p v-if="companyStore.isEFC">Bitte richten Sie rechtliche Fragen zu dieser Website an 2257inquiries@ersties-custodian.com.</p>

        <p>1.7.)</p>

        <p>Das Angebot auf Abschluss einer Mitgliedschaft richtet sich ausschließlich an volljährige Nutzer.</p>

        <p>1.8.)</p>

        <p>
          Der Anbieter speichert den Inhalt abgeschlossener Verträge in seiner EDV. Dem Nutzer wird der Inhalt eines mit ihm abgeschlossenen
          Vertrags in der Vertragsbestätigung per E-Mail übermittelt. Eine anderweitige Möglichkeit zur Einsicht in den Vertragstext besteht für
          den Nutzer nicht. Ihm wird daher empfohlen, die Vertragsbestätigung auszudrucken, zu speichern oder in sonstiger Weise aufzubewahren.
        </p>

        <p>2. ANMELDUNG UND VERTRAGSABSCHLUSS</p>

        <p>2.1.)</p>

        <p>Entgeltliche Mitgliedschaft</p>

        <p>
          Für eine entgeltliche Mitgliedschaft, die den vollständigen Zugang zu allen Inhalten des Portals ermöglicht, gibt der Nutzer neben den
          für eine kostenlose Mitgliedschaft erforderlichen Daten zusätzlich den gewünschten Mitgliedschaftstarif (im Bereich „Mitgliedschaft
          wählen“), die gewünschte Zahlungsmethode (im Bereich „Zahlart auswählen“ – z.B. Lastschrift oder Kreditkarte) und die hierfür
          erforderlichen Daten des Zahlungsmittels (z.B. Kontoverbindung oder Kartendaten) an. Bis zum Betätigen dieser Schaltfläche hat der
          Nutzer jederzeit die Möglichkeit, Eingabefehler zu korrigieren oder vom Vertragsschluss ganz Abstand zu nehmen.
        </p>

        <p>
          Durch Betätigen der Schaltfläche übermittelt der Nutzer seine Angaben verbindlich an den Anbieter, wodurch der gewählte Nutzungsvertrag
          verbindlich geschlossen wird. Der Anbieter bestätigt den Abschluss des Mitgliedschaftsvertrags per E-Mail („Vertragsbestätigung“).
        </p>

        <p>2.2.)</p>

        <p>
          Die Anmeldung des Kunden erfolgt online über das vom Anbieter (oder einen seiner Vertragspartner) zum Abruf bzw. Download
          bereitgestellte Online-Vertragsformular („Anmeldemaske“). Die Übermittlung der Daten des Kunden erfolgt über eine sichere Verbindung.
        </p>

        <p>2.3.)</p>

        <p>
          Mit Absenden der vollständig ausgefüllten Anmeldemaske gibt der Kunde sein Angebot zum Abschluss eines Vertrages ab. Der Zugang zum
          Angebot und die Nutzung der im Mitgliederbereich zur Verfügung stehenden Dienste einschließlich Abruf der (zur Online-Wiedergabe)
          verfügbaren Medien erfolgen durch eine Kombination aus einem Benutzernamen (sog. Username) und einem Passwort. Der Kunde erhält nach
          erfolgreicher Anmeldung eine Bestätigungsmail mit diesen Daten, einem Passwort (einem individuellen Identifikationscode) und
          zusätzliche Informationen sowie gesetzlich vorgeschriebene Hinweise. Außerdem wird dem Kunden (in der Regel binnen weniger Sekunden)
          nach dem Absenden des Formulars der Erfolg (bzw. die Ablehnung) seiner Anmeldung unmittelbar am Bildschirm angezeigt. Mit Anzeige der
          erfolgreichen Registrierung (als neues Mitglied) und Erhalt der Bestätigungsmail hat der Anbieter den Vertrag angenommen.
        </p>

        <p>Vorsätzliche Falschangaben bei Anmeldung sowie unberechtigte Nutzung des Angebots werden straf- und zivilrechtlich verfolgt!</p>

        <p>2.4.)</p>

        <p>
          Den Abrechnungszeitraum („Abrechnungsintervall“) kann jeder Kunde bei Auswahl der gewünschten Mitgliedschaft selbst wählen. Er wird dem
          Kunden auf dem Bildschirm (in der Anmeldemaske sowie in dem Bereich „join now“) angezeigt.
        </p>

        <p>2.5.)</p>

        <p>
          Alle Verträge („Mitgliedschaft“) werden auf unbestimmte Zeit abgeschlossen. Die Mitgliedschaft verlängert sich am Ende ihrer Laufzeit
          jeweils um die Länge der ursprünglich gewählten Laufzeit.
        </p>

        <p>2.6.)</p>

        <p>
          Jeder Vertrag kann, wie in Ziffer 4. dieser AGB beschrieben, gekündigt werden. Bei fristgerechter Kündigung endet die Mitgliedschaft
          jeweils mit Ende des gerade laufenden, ansonsten mit Ablauf des nächstfolgenden Abrechnungsintervalls (Nur Kündigungen aus wichtigem
          Grund sind ohne Einhaltung von Fristen und Terminen möglich).
        </p>

        <p>2.7.)</p>

        <p>Der Vertragstext wird von uns nicht gespeichert. Der Vertragsschluss ist derzeit in deutscher und englischer Sprache möglich.</p>

        <p>2.8.)</p>

        <p>Kostenlose Mitgliedschaft</p>

        <p>
          Zum Abschluss einer kostenlosen Mitgliedschaft braucht der Nutzer im Bereich „Mitglied werden“ des Portals lediglich seine
          E-Mail-Adresse, ein selbst gewähltes Pseudonym („Benutzername“) und ein selbst gewähltes Passwort anzugeben. Über die Schaltfläche
          „Fertig, weiter“ übermittelt der Nutzer seine Daten an den Anbieter.
        </p>

        <p>
          Sofern der gewählte Benutzername nicht bereits durch einen Dritten verwendet wird, bestätigt der Anbieter den Abschluss des
          Nutzungsvertrags unmittelbar im Anschluss per E-Mail an die vom Nutzer angegebene E-Mail-Adresse. Der Nutzer kann sich im Anschluss
          jederzeit unter Angabe seines Benutzernamens und seines Passworts im Mitgliederbereich des Anbieters anmelden.
        </p>

        <p>
          Beide Parteien können die kostenlose Mitgliedschaft jederzeit ohne Einhaltung einer Frist ordentlich kündigen. Jede Kündigung bedarf zu
          ihrer Wirksamkeit der Textform.
        </p>

        <p>2.9.)</p>

        <p>Ergänzende Leistungen, Erwerb und Nutzung von Coins</p>

        <p>
          Die Kamera-Chat-Funktion ist eine Leistung, die nicht bereits im Entgelt für die Mitgliedschaft enthalten ist. Sie ist gesondert zu
          vergüten, wobei sich das Entgelt nach der Dauer der Nutzung richtet.
        </p>

        <p>
          Je Minute der Nutzung erhebt der Anbieter ein Entgelt von 10 Coins, wobei es sich bei einem „Coin“ nicht um eine Währung oder e-Geld,
          sondern um eine bloße Recheneinheit handelt. Der Nutzer kann für jeweils 10 Coins eine Minute lang die Kamera-Chat-Funktion nutzen.
        </p>

        <p>
          Der Nutzer kann eine beliebige Anzahl Coins gegen Entgelt erwerben, wobei die selben Zahlungsmittel zur Verfügung stehen wie für die
          entgeltliche Mitgliedschaft. Erworbene Coins können nicht zurückgegeben werden; soweit aber dem Nutzer ein Widerrufsrecht zusteht,
          bleibt dieses unberührt.
        </p>

        <p>Erworbene Coins bleiben zeitlich unbegrenzt gültig.</p>

        <p>3. VERTRAGSINHALT/KOSTENPFLICHTIGE TESTPHASE</p>

        <p>3.1.)</p>

        <p>
          Der Inhalt jedes einzelnen Vertrages („Mitgliedschaft“) ergibt sich aus diesen AGB in Verbindung mit den in der Anmeldemaske
          ausgewiesenen Bestimmungen einschließlich der vom Kunden gewählten Preise/ Abrechnungsintervalle.
        </p>

        <p>
          Vertragsinhalt ist die Einräumung eines Zugangs zum passwortgesicherten (siehe Punkt 2.2.) Mitgliederbereich des
          vertragsgegenständlichen Online-Unterhaltungsangebots gegen Entrichtung der vereinbarten Mitgliedsgebühr unter Berücksichtigung der
          unter Punkt 9 vereinbarten Mindestverfügbarkeit des Online-Dienstes. Der Kunde hat innerhalb des Mitgliederbereichs die Möglichkeit,
          dort auf Abruf zur Verfügung stehende Inhalte (gebräuchliche Standardmedien wie z.B. Videos oder Fotos) online abzuspielen sowie
          sonstige Leistungen bzw. Dienste für Mitglieder (z.B. Chats) zu nutzen – die erforderlichen Details zur Nutzung sind jeweils auf der
          Site publiziert.
        </p>

        <p>
          Für die Nutzung dieser im Mitgliederbereich abrufbaren Standardmedien und Leistungen/Dienste gebührt dem Anbieter keine über die
          vereinbarte Mitgliedsgebühr hinausgehende gesonderte Vergütung. Für die vom Kunden zu bezahlenden Mitgliedsbeiträge ist somit
          Anzahl/Dauer seines Aufenthalts/seiner Besuche im Mitgliederbereich sowie das quantitative Ausmaß der in Anspruch genommenen Leistungen
          irrelevant.
        </p>

        <p>
          Der Anbieter behält sich jedoch vor, im Mitgliederbereich über die abrufbaren Standardmedien und allgemeinen Leistungen/Dienste
          hinausgehende, einzelne kostenpflichtige Zusatzleistungen anzubieten (v.a. Livecams). Diese, über die Mitgliedsgebühr hinausgehend
          kostenpflichtigen Zusatzleistungen werden besonders als solche gekennzeichnet.
        </p>

        <p>
          Die Nutzung der Mitgliedschaft ist ausschließlich dem Kunden persönlich gestattet. Dieser darf weder sein Passwort, noch die Nutzung
          selbst einem Dritten überlassen (siehe Punkt 10.).
        </p>

        <p>3.2.)</p>

        <p>Kostenpflichtige Testphase:</p>

        <p>
          Auch bei Vereinbarung einer kostenpflichtigen Testphase muss gekündigt werden! Diese Testphase ist – wie bei dessen Auswahl in der
          Anmeldemaske angezeigt - kein befristeter Vertrag, und läuft nach der Testphase nicht etwa automatisch aus, sondern räumt dem Kunden
          vielmehr die Möglichkeit ein, das auf unbestimmte Dauer erworbene, kostenpflichtige Nutzungsrecht in einer ersten Testphase
          („Testzeitraum“ je nach Angebot bis max. 7 Tage ab Vertragsabschluss wählbar) zu testen und bei etwaigem Nichtgefallen zu erleichterten
          Bedingungen aufkündigen zu können: bei Kündigung innerhalb des Testzeitraums braucht der Kunde demnach nur eine besonders kurze
          Kündigungsfrist einzuhalten. Es wird nur die Gebühr für den Testzeitraum, und nicht etwa gleich eine ganze Monatsgebühr, verrechnet.
          (Hinweis: ohne Probekauf wäre die Mitgliedschaft frühestens nach 30 Tagen aufkündbar.) Zur Kündigung siehe Punkt 4.I.
        </p>

        <p>
          Der Testzeitraum bildet zugleich das erste Abrechnungsintervall der - immer auf unbestimmte Dauer abgeschlossenen - Mitgliedschaft. Die
          dafür zu leistende gesonderte Mitgliedsgebühr scheint in der Anmeldemaske ebenso auf wie alle übrigen zur Auswahl stehenden Tarife und
          Abrechnungsintervalle. Sofern der Kunde nicht kündigt, wird die Mitgliedsgebühr anschließend alle 30 Tage (entsprechend dem Preis für
          das vereinbarte „Standardintervall“) verrechnet.
        </p>

        <p>
          Das Wesen der kostenpflichtigen Testphase, einschließlich Erfordernis einer Kündigung und die konkret verrechneten Mitgliedsentgelte
          werden in der „Anmeldemaske“ übersichtlich angezeigt; der Anbieter wird auch in seine Bestätigungsmail entsprechende Hinweise
          aufnehmen.
        </p>

        <p>4. KÜNDIGUNG</p>

        <p>4.1.)</p>

        <p>
          Eine Kündigung ist durch beide Vertragspartner ohne Angabe von Gründen schriftlich möglich, wie in den nachstehenden Punkten (2 – 6)
          beschrieben:
        </p>

        <p>
          <template v-if="companyStore.isCombinator"> Combinator AG, Samstagernstrasse 55, 8832 Wollerau </template>
          <template v-else> EFC GmbH, Sonnenhof 3, 8808 Pfäffikon </template>
          , via email an info (at) ersties.com
        </p>

        <p>oder per Post an die oben genannte Anschrift.</p>

        <p>4.2.)</p>

        <p>
          Im Falle einer Kündigung per Post muss die Kündigung des Kunden von ihm unterschrieben sein und alle für ihre Zuordnung wesentlichen
          Mitgliedschaftsdaten enthalten. Diese Daten sind mindestens
        </p>

        <p>Name des Kunden oder die bei Vertragsabschluss verwendete Emailadresse und Username</p>

        <p>Angebot (Website), welches gekündigt wird</p>

        <p>Hinweis: Wir empfehlen jedem Kunden, für Beweiszwecke einen Zustellnachweis seiner Kündigungserklärung aufzubewahren.</p>

        <p>4.3.)</p>

        <p>Auch kostenpflichtige Testphasen müssen gekündigt werden.</p>

        <p>4.4.) Kündigungsfrist und -termin:</p>

        <p>
          Die Kündigungserklärung muss dem Vertragspartner spätestens 12 Stunden vor Beginn des nächsten Abrechnungsintervalls zugehen. Die
          Abrechnungsintervalle werden ab Vertragsabschluss jeweils minutengenau berechnet!
        </p>

        <p>
          Hinweis: sollte der Kunde bei Anmeldung kein längeres Abrechnungsintervall gewählt haben, beträgt das „Standardintervall“ jeweils 30
          Tage (720 Stunden)
        </p>

        <p>
          Bsp.: die Bestätigungsmail wird dem Kunden am 01.01.2007 um 11:00 Uhr übermittelt; die Mitgliedsgebühr ist vereinbarungsgemäß im
          „Standardintervall“ von 30 Tagen/ 720 Std. zu verrechnen. Die spätestmögliche Kündigung müsste dem Anbieter am 30.01.2007 um 23:00 Uhr
          bereits zugegangen sein.
        </p>

        <p>
          Bei kostenpflichtigen Testphasen muss dem Anbieter die Kündigungserklärung des Mitglieds innerhalb der vereinbarten Testphase (je nach
          Wahl des Kunden bis maximal 7 Tage), und zwar spätestens 8 Stunden vor Beginn des nächsten Abrechnungsintervalls zugehen.
        </p>

        <p>
          Hinweis: Für die Kündigung dieser Testphase empfiehlt sich – speziell wenn der Kunde nur eine kurze Testphase gewählt hat - daher
          primär die Email-Kündigung.
        </p>

        <p>
          Bsp.: wie oben, jedoch hat der Kunde eine Testphase mit einem Zeitraum von 5 Tagen gewählt: die spätestmögliche Kündigung müsste dem
          Anbieter am 06.01.2007 um 03:00 Uhr vorliegen; anschließend wäre die nächste Kündigung fristgerecht, wenn diese dem Anbieter spätestens
          am 01.02.2007 um 11:00 Uhr vorliegt.
        </p>

        <p>
          Eine fristgerecht zugegangene Kündigungserklärung wird mit Ablauf des gerade aktuell laufenden Abrechnungsintervalls (ansonsten mit
          Ablauf des nächstfolgenden Abrechnungsintervalls) wirksam.
        </p>

        <p>4.5.)</p>

        <p>
          Nach erfolgter Online-Kündigung erhält der Kunde sofort eine automatisierte Bestätigung der Kündigung am Bildschirm angezeigt, sowie
          eine Information über den Zeitpunkt der Beendigung seiner Mitgliedschaft. Der Anbieter übermittelt dem Kunden in jedem Fall auch eine
          Kündigungsbestätigung an seine Emailadresse.
        </p>

        <p>4.6.)</p>

        <p>Außerordentliche Kündigung aus wichtigem Grund:</p>

        <p>
          Das Recht zur außerordentlichen Kündigung aus wichtigem Grund (= „fristlose Kündigung“) bleibt für beide Vertragspartner unberührt.
        </p>

        <p>
          Gründe, die den Anbieter zur fristlosen Kündigung sowie zur sofortigen Sperre des Accounts des Mitglieds (= dessen Zugang zum
          Mitgliederbereich) berechtigen, sind insbesondere:
        </p>

        <p>falsche oder rechtswidrige Angaben bei der Anmeldung</p>

        <p>Missbrauch der bereitgestellten Dienste (z.B. Versuch der Abwerbung anderer Mitglieder)Weitergabe der Zugangsdaten an Dritte</p>

        <p>Erstellung rechtswidriger Inhalte in dem bereitgestellten Online-Unterhaltungsangebot</p>

        <p>
          trotz Abmahnung wiederholter oder derart schwerwiegender einmaliger Verstoß gegen die Allgemeinen Geschäftsbedingungen, dass dem
          Anbieter ein Festhalten am Vertrag unzumutbar ist (z.B. Verbreiten von Viren)
        </p>

        <p>Beeinträchtigung oder Beschädigung der Funktionsfähigkeit des Online- Unterhaltungsangebots, auch in Teilen</p>

        <p>Zahlungsverzug des Mitglieds (z.B. infolge Stornierung oder Rückbuchung geschuldeter Mitgliedsbeiträge).</p>

        <p>5. WIDERRUFSBELEHRUNG</p>

        <p>5.1.)</p>

        <p>
          Einem Nutzer, der seinen gewöhnlichen Aufenthalt in einem Mitgliedsstaat der Europäischen Union hat und als Verbraucher handelt, steht
          ein Widerrufsrecht gemäß den gesetzlichen Bedingungen zu. Verbraucher ist jede natürliche Person, die ein Rechtsgeschäft zu Zwecken
          abschließt, die überwiegend weder ihrer gewerblichen noch ihrer selbständigen beruflichen Tätigkeit zugerechnet werden können. Die
          Einzelheiten ergeben sich aus der Widerrufsbelehrung.
        </p>

        <p>5.2.)</p>

        <p><b>Widerrufsbelehrung für die entgeltliche Mitgliedschaft</b></p>

        <p><b>Widerrufsrecht</b></p>

        <p>
          Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu widerrufen. Die Widerrufsfrist beträgt vierzehn
          Tage ab dem Tag des Vertragsabschlusses.
        </p>

        <p>
          Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (
          <template v-if="companyStore.isCombinator"> Combinator AG, Samstagernstrasse 55, 8832 Wollerau </template>
          <template v-else> EFC GmbH, Sonnenhof 3, 8808 Pfäffikon </template>
          , E-Mail info (@ )ersties.com) mittels einer eindeutigen Erklärung (z.B. ein mit der Post versandter Brief oder E-Mail) über Ihren
          Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür das beigefügte Muster-Widerrufsformular verwenden, das jedoch
          nicht vorgeschrieben ist.
        </p>

        <p>
          Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des Widerrufsrechts vor Ablauf der
          Widerrufsfrist absenden.
        </p>

        <p><b>Folgen des Widerrufs</b></p>

        <p>
          Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten haben, einschließlich der Lieferkosten
          (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass Sie eine andere Art der Lieferung als die von uns angebotene,
          günstigste Standardlieferung gewählt haben), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die
          Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel,
          das Sie bei der ursprünglichen Transaktion eingesetzt haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart; in
          keinem Fall werden Ihnen wegen dieser Rückzahlung Entgelte berechnet.
        </p>

        <p><b>Erlöschen des Widerrufsrechts</b></p>

        <p>
          Das Widerrufsrecht erlischt bei einem Vertrag über die Lieferung von nicht auf einem körperlichen Datenträger befindlichen digitalen
          Inhalten auch dann, wenn der Unternehmer mit der Ausführung des Vertrags begonnen hat, nachdem der Verbraucher
        </p>

        <p>1. ausdrücklich zugestimmt hat, dass der Unternehmer mit der Ausführung des Vertrags vor Ablauf der Widerrufsfrist beginnt, und</p>

        <p>
          2. seine Kenntnis davon bestätigt hat, dass er durch seine Zustimmung mit Beginn der Ausführung des Vertrags sein Widerrufsrecht
          verliert.
        </p>

        <br />
        <p><b>Muster-Widerrufsformular</b></p>

        <p>(Wenn Sie den Vertrag widerrufen wollen, dann füllen Sie bitte dieses Formular aus und senden Sie es zurück.)</p>

        <p>
          An
          <template v-if="companyStore.isCombinator"> Combinator AG, Samstagernstrasse 55, 8832 Wollerau </template>
          <template v-else> EFC GmbH, Sonnenhof 3, 8808 Pfäffikon </template>
          , E-Mail info (@ )ersties.com
        </p>

        <p>
          – Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über den Kauf der folgenden Waren (*)/die Erbringung der
          folgenden Dienstleistung (*):
        </p>

        <p>– Bestellt am (*)/erhalten am (*):</p>

        <p>– Name des/der Verbraucher(s):</p>

        <p>– Anschrift des/der Verbraucher(s):</p>

        <p>– Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier):</p>

        <p>– Datum:</p>

        <p>(*) Unzutreffendes streichen.</p>

        <p>6. PREISE UND ZAHLUNGSINFORMATIONEN</p>

        <p>6.1.)</p>

        <p>Preise, Preisänderungen und Verrechnungsarten:</p>

        <p>
          Die je nach Online-Unterhaltungsangebot und Herkunftsland ggf. unterschiedlich verfügbaren Angebote, Verrechnungsarten (Kreditkarte,
          elektronisches Lastschrift-verfahren ELV usw.), Mitgliedsbeiträge und Abrechnungsintervalle werden dem Kunden auf der Anmeldemaske zu
          seiner Auswahl angezeigt. Weitere Formulare begleiten den Kunden dann durch die seiner Auswahl entsprechende Zahlungsabwicklung. Die
          Abbuchungen auf dem Kreditkarten- bzw. Bankkonto erfolgen jeweils unter entsprechender Bezeichnung. Die Übermittlung der Daten des
          Kunden an den Anbieter erfolgt über eine sichere Verbindung.
        </p>

        <p>Alle ausgewiesenen Preise verstehen sich in EUR inklusive einer eventuell anfallenden gesetzlichen Umsatzsteuer.</p>

        <p>
          Hinweis: der Kunde (siehe auch Punkt 11.3.) benötigt für die Nutzung der vertragsgegenständlichen Leistungen insbesondere einen
          Computer einschließlich Internetzugang; die hierfür entstehenden Kosten fallen ausschließlich in die Sphäre des Kunden und sind von der
          mit dem Anbieter vereinbarten Mitgliedsgebühr nicht abgegolten.
        </p>

        <p>
          Geleistete Zahlungen werden zuerst zur Begleichung offener Mahngebühren, angefallener Stornospesen und Verzugszinsen, sodann der
          offenen Mitgliedsgebühren verwendet (siehe dazu auch Punkt 7 Zahlungsverzug, Rückbelastungen und Stornierungen).
        </p>

        <p>
          Eine eventuelle Preiserhöhung wird dem Kunden mindestens 5 Wochen zuvor per Email mitgeteilt, sodass es ihm möglich ist, ggf.
          rechtzeitig vorher eine ordentliche Kündigung vorzunehmen. Bei einem vereinbarungsgemäß längerem Abrechnungsintervall als 30 Tage ist
          der für die Preiserhöhung vorgesehene Termin angemessen festzusetzen, um dem Kunden auch in einem solchen Fall eine rechtzeitige
          Vertragskündigung zu ermöglichen.
        </p>

        <p>6.2.)</p>

        <p>Mitgliedschaft und Abrechnungsintervalle:</p>

        <p>
          Die Abrechnung der Mitgliedsgebühren erfolgt durch periodische Buchungen je nach vom Kunden angegebener Verrechnungsart (insbesondere
          durch Kreditkarte oder im Elektronischen Lastschriftverfahren ELV) und ausgewähltem Abrechnungsintervall. Die Abrechnungsintervalle
          regeln die Fälligkeit der Mitgliedsbeiträge (= zu welchen Zeitpunkten der Kunde das vereinbarte Entgelt jeweils leisten muss). Der
          Kunde hat die Mitgliedsgebühr zu Beginn jedes Abrechnungsintervalls im Voraus zu leisten.
        </p>

        <p>
          Beispiel: der Kunde hat das in der Anmeldemaske ausgewiesene „Standard-Abrechnungsintervall“ von jeweils 30 Tagen gewählt: das
          bedeutet, dass die Mitgliedsgebühr beginnend mit Vertragsabschluss im 30 Tages-Rhythmus fällig und abgebucht/eingezogen wird.
        </p>

        <p>Angegebene Abrechnungsintervalle werden – beginnend mit Vertragsabschluss – jeweils minutengenau berechnet.</p>

        <p>6.3.)</p>

        <p>Kreditkarten- und Lastschriftzahlung:</p>

        <p>
          Bei Bezahlung mittels Kreditkarte- oder Lastschriftzahlung hat der Kunde dafür Sorge zu tragen, dass Kreditkarte oder Bankkonto nicht
          gesperrt oder abgelaufen sind; im Falle einer vom Kunden verschuldeten Rückbuchung hat dieser die anfallenden Spesen (siehe Punkt 7.)
          zu ersetzen.
        </p>

        <p>6.4.)</p>

        <p>Gesondert entgeltpflichtige Zusatz-Angebote wie v.a. Livecams:</p>

        <p>
          Der Anbieter behält sich vor, seinen Kunden im Mitgliederbereich über die vereinbarten Inhalte und Leistungen/Dienste hinausgehende,
          vereinzelte Zusatzleistungen, wie v.a. die Inanspruchnahme von Livecams, gegen zusätzliches Entgelt anzubieten. Diese - zusätzlich zum
          vereinbarten periodischen Mitgliedsbeitrag zu vergütenden – Zusatz-Angebote werden im Mitgliederbereich gesondert gekennzeichnet. Siehe
          dazu auch Punkt 3.1. (Vertragsinhalt).
        </p>

        <p>
          Die Inanspruchnahme derartiger Zusatz-Angebote ist entweder durch Kauf so genannter „COINS“ oder durch ein so genanntes „Upgrade der
          Mitgliedschaft“ (= Aufstocken des Mitgliedsbeitrages) möglich. Der jeweilige Preis ist direkt beim Zusatz-Angebot ausgewiesen. Eine
          Verpflichtung zum Kauf oder Nachkauf von COINS oder zum Update der Mitgliedschaftsgebühr besteht selbstverständlich nicht!
        </p>

        <p>COINS:</p>

        <p>
          Der Kunde kauft nach freier Entscheidung ein bestimmtes „COINS-Kontingent“ (eine bestimmte Anzahl von COINS) zum ausgewiesenen Preis –
          die COINS fungieren analog einer Wertkarte bzw. einem Gutschein. Für jede in Anspruch genommene kostenpflichtige Zusatzleistung wird
          dem Kunden anschließend eine bestimmte (auf der Site angezeigte) Anzahl von COINS abgezogen, bis sein gekauftes COINS-Kontingent
          schließlich vollständig erschöpft ist. Der Kauf von COINS führt zu keinerlei zukünftiger Abnahmeverpflichtung, sondern wird lediglich
          der Kaufpreis für das vom Kunden konkret gewünschte COINS-Kontingent verrechnet. Die vereinbarte Mitgliedsgebühr, welche im vom Kunden
          gewählten Abrechnungsintervall periodisch zu leisten ist, bleibt hiervon völlig unberührt.
        </p>

        <p>7.</p>

        <p>ZAHLUNGSVERZUG, RÜCKBELASTUNGEN UND STORNIERUNGEN</p>

        <p>7.1.)</p>

        <p>Stornierungen und Rückbelastungen:</p>

        <p>
          Der Kunde verpflichtet sich zur Tragung sämtlicher Kosten, die durch (mangels Deckung oder aus anderen vom Kunden verschuldeten
          Gründen) nicht eingelöste oder vom Kunden zu Unrecht stornierte Buchungen entstehen. Diese Kosten setzen sich aus Abrechnungs- und
          Clearinggebühren sowie Stornogebühr zusammen, welche dem Anbieter seitens der Bank, des Kreditkartenunternehmens bzw. des sonst
          eingebundenen Abrechnungsdienstleisters (aufgrund der vom Kunden verschuldeten Stornierung/Rückbuchung) verrechnet werden, und sind
          ihrer Höhe nach von der jeweils verwendeten Zahlform sowie der beteiligten Bank (Kreditkartenunternehmung/Abrechnungs-dienstleister)
          abhängig, weshalb sie einen Betrag zwischen EUR 9,00 bis EUR 60,00 ausmachen können. Dem Kunden bleibt nachzuweisen, dass dem Anbieter
          geringere Kosten entstanden sind.
        </p>

        <p>7.2.)</p>

        <p>Mahnung, Inkasso und Gerichtsverfahren:</p>

        <p>
          Der Anbieter ist berechtigt, dem Kunden für jede nach Fälligkeit erfolgende Mahnung die angefallenen notwendigen und zweckdienlichen
          administrativen Mahnspesen in Höhe von je EUR 6,00 in Rechnung zu stellen. Der Kunde wird ausdrücklich darauf hingewiesen, dass sich
          der Anbieter vorbehält, die Forderungsverfolgung bereits nach der ersten Mahnung an ein Inkassoinstitut bzw. an einen Rechtsanwalt zu
          übergeben.
        </p>

        <p>
          Kommt der Kunde trotz Benachrichtigung seinen Zahlungsverpflichtungen nicht innerhalb der gesetzten Nachfrist nach, so hat dieser
          Verzugszinsen in der Höhe von 8 % über dem Basiszinssatz p.a. ab fruchtlosem Verstreichen der Nachfrist, sowie die tatsächlich
          angefallenen und zur zweckentsprechenden außergerichtlichen Betreibung notwendigen Aufwendungen zu bezahlen, soweit diese im
          angemessenen Verhältnis zur betriebenen Forderung stehen. Der Kunde nimmt zur Kenntnis, dass die dadurch entstehenden und von ihm zu
          tragenden Kosten einerseits von der Höhe der offenen Forderungen, andererseits von den zur Forderungsverfolgung notwendigen
          Betreibungsmaßnahmen abhängen und daher vorab und global nicht feststehen können.
        </p>

        <p>7.3.)</p>

        <p>Sonstige Verzugsfolgen:</p>

        <p>
          Der Anbieter ist, sofern der Kunde trotz Benachrichtigung nach 7.2. seiner Zahlungsverpflichtung nicht innerhalb der gesetzten
          Nachfrist nachkommt, entsprechend den diesbezüglichen gesetzlichen Vorgaben zur Zurückbehaltung weiterer Leistungen bis zur Erbringung
          der vom Kunden geschuldeten Gegenleistung berechtigt.
        </p>

        <p>
          Überdies ist der Anbieter nach Maßgabe von Ziffer 4. Nr. 6 dieser AGB zur außerordentlichen Kündigung aus wichtigem Grund berechtigt,
          aber nicht verpflichtet!
        </p>

        <p>
          Nichteinhaltung von Verbindlichkeiten enthebt den Kunden keinesfalls von seinen Zahlungsverpflichtungen aus laufender Mitgliedschaft!
          Die Mitgliedschaft bleibt bis zu einer Kündigung seitens des Kunden oder des Anbieters aufrecht!
        </p>

        <p>Bei Zahlungsverzug kann dem Kunden überdies das Eingehen weiterer Mitgliedschaften oder der Kauf von „COINS“ verwehrt werden.</p>

        <p>8. INHALTE UND COPYRIGHTS</p>

        <p>8.1.) Inhalte:</p>

        <p>
          Es wird auf Punkt 3.1.) Vertragsinhalt verwiesen. Die im Mitgliederbereich auf Abruf zur Verfügung stehenden Inhalte (z.B. Videos und
          Bildergalerien sowie sonstige Unterhaltungsmedien) können demnach Online abgerufen und eingesehen werden; bei entsprechender
          Vereinbarung steht dem Kunden zudem die Möglichkeit des Downloads (Herunterladen) zur Verfügung.
        </p>

        <p>8.2.) Copyrights:</p>

        <p>
          Das Online-Unterhaltungsangebot und alle darin zur Verfügung gestellten Inhalte und Leistungen/Dienste sind ausschließlich für den
          privaten, nicht kommerziellen Gebrauch der Kunden bestimmt. Jede anderwärtige Verwendung ist strengstens untersagt. Alle
          veröffentlichten Inhalte stehen unter urheber- bzw. leistungsrechtlichem Schutz und dürfen über die zwischen Kunden und Anbieter
          getroffenen Vereinbarungen hinausgehend weder kopiert, noch weiter vermarktet werden.
        </p>

        <p>9. VERFÜGBARKEIT DES DIENSTES</p>

        <p>
          Der Anbieter erbringt seine Leistungen mit höchstmöglicher Zuverlässigkeit und Verfügbarkeit. Jede Wartung des Systems und jede
          Aktualisierung des Online-Dienstes führt jedoch dazu, dass während dieser Zeit das Online-Unterhaltungsangebot nur eingeschränkt
          verfügbar ist oder kurzfristig sogar ausfällt; laufende Updates der Sicherheitssysteme und Hochladen neuer Inhalte durch den Anbieter
          entsprechen aber gerade den Interessen der Kunden!
        </p>

        <p>
          Des Weiteren ist allgemein bekannt, dass Internetseiten ihrem Wesen entsprechend Störeinflüssen außerhalb der Sphäre ihrer Betreiber
          ausgesetzt sein können (z.B. bei höherer Gewalt, Ausfall des Stromnetzes, durch rechtswidrigen Eingriff Dritter z.B. in Form von
          „Hackern“ usw.).
        </p>

        <p>
          Zudem kann es auch beim Datenaustausch bzw. Transfer vom Provider des Anbieters über die Providerkette, welche die Verbindung zum
          Provider des Kunden darstellt, zu Problemen kommen, die nicht im Bereich des Anbieters liegen.
        </p>

        <p>
          Eine zeitlich und örtlich uneingeschränkte, 100%ige Verfügbarkeit des Online-Unterhaltungsangebots ist somit unmöglich und zwischen den
          Vertragsparteien daher auch nicht vereinbart. Als Vertragsinhalt vereinbaren die Vertragspartner stattdessen eine durchschnittliche
          Mindestverfügbarkeit des Online-Unterhaltungsangebots pro Abrechnungsintervall von 90% - beim „Standard-Abrechnungsintervall“ von 30
          Tagen ist vom Anbieter daher zu gewährleisten, dass das Online-Unterhaltungsangebot mindestens 648 Stunden für den Kunden verfügbar
          ist.
        </p>

        <p>10. PFLICHT ZUR GEHEIMHALTUNG DER MITGLIEDSDATEN UND VERBOT DER</p>

        <p>ÜBERLASSUNG DES ZUGANGS AN DRITTE / MINDERJÄHRIGE</p>

        <p>
          Der Kunde hat die Daten seiner Bestätigungsmail, seinen Username, sein Passwort und Passwort geheim zu halten und für seine Sphäre
          sicherzustellen, dass genannte Daten keinem Dritten zugänglich werden. Der Kunde hat weiterhin dafür Sorge zu tragen, dass seine
          Zugangsdaten innerhalb seiner Sphäre auch nicht durch Zufall anderen Personen, vor allem minderjährigen Familienmitgliedern, zugänglich
          sind. Der Kunde haftet für Handlungen, die unter Verwendung genannter Daten vorgenommen werden, wenn er diese Mitgliedsdaten Dritten
          weitergibt oder diese durch sein Verschulden Dritten bekannt geworden sind, z.B. dadurch, dass er diese Daten sorglos (ohne Vorkehrung
          gegen unbefugten Zugriff) verwahrt hat.
        </p>

        <p>
          Für den Fall der „Mehrfachnutzung einer Mitgliedschaft“ (durch vom Kunden verschiedene Personen unter Benützung dessen Passwort usw.)
          behält sich der Anbieter die Verrechnung der dadurch entgangenen Mitgliedsgebühren vor. Der Kunde ist verpflichtet, den Anbieter
          unverzüglich über jede missbräuchliche Benutzung seines Usernames und Passwortes sowie über jegliche sonstige Verletzung von
          Sicherheitsvorschriften zu unterrichten, insbesondere bei Verdacht, dass seine Mitgliedsdaten Dritten zur Kenntnis gelangt sein
          könnten.
        </p>

        <p v-if="companyStore.isEFC">
          Ersties ist berechtigt, alle Rechte und Pflichten aus den Nutzungsbedingungen und der Vertragsbeziehung mit dem Abonnenten auf ein
          verbundenes Unternehmen oder einen Dritten zu übertragen.
        </p>

        <p>11. ALLGEMEINE PFLICHTEN DES MITGLIEDS</p>

        <p>11.1.) Informationspflicht:</p>

        <p>
          Der Kunde hat dem Anbieter sämtliche Informationen, die dieser zur Abrechnung, Benachrichtigung und Erhaltung der Sicherheit benötigt,
          wahrheitsgemäß zu erteilen und Änderungen unverzüglich mittels Email mitzuteilen. Je nach Dringlichkeit ist auch eine Benachrichtigung
          auf dem Postweg zulässig. Insbesondere sind dem Anbieter mitzuteilen:
        </p>

        <p>a) Änderungen des Gültigkeitsdatums der Kreditkarte oder Bankverbindung, die in Verbindung mit dem Angebot benutzt wird</p>

        <p>b) Änderungen der Rechnungs- oder Wohnadresse sowie der angegebenen Email</p>

        <p>
          c) offensichtliche Verletzungen der Sicherheit, so zum Beispiel Verlust, Diebstahl oder die unerlaubte Benutzung eines Benutzernamens
          oder Passwortes.
        </p>

        <p>
          Falschangaben oder die Nichterfüllung genannter Informationspflichten können zivil- und strafrechtliche Folgen (z.B.
          Schadenersatzforderungen, Anzeige wegen Verdacht des Betruges, Konventionalstrafe) nach sich ziehen!
        </p>

        <p>11.2.) Nutzungsverhalten einschließlich Werbeverbot:</p>

        <p>
          Dem Kunden ist untersagt, im Rahmen der Inanspruchnahme gegenständlichen Online-Unterhaltungsangebots gesetzliche Bestimmungen, Rechte
          Dritter, diese AGB sowie die „guten Sitten“ zu verletzen.
        </p>

        <p>
          An oder über die Internetseiten des Anbieters dürfen keine Viren, Trojanischen Pferde, Würmer, Zeitbomben, Cancelbots oder andere
          Daten, Programmroutinen oder Inhalte, welche der Soft- oder Hardware des Anbieters, dessen Kunden oder Dritten Schaden verursachen
          könnten, übermittelt oder verbreitet werden.
        </p>

        <p>
          Die Verschaffung, Duldung und Verwendung unautorisierten Zuganges zum Angebot und das Übergehen von Sicherheitssperren stellen eine
          Vertragsverletzung dar und können straf- und zivilrechtlich verfolgbar sein.
        </p>

        <p>
          Den Mitgliedern ist untersagt, anlässlich der Nutzung des gegenständlichen Online-Unterhaltungsangebotes Werbung für eigene Angebote
          und/oder andere Anbieter zu machen, auch wenn die hierbei beworbenen Angebote eine andere Branche betreffen sollten (z.B. Bewerbung
          eines Arzneimittels in Chatrooms, als Blog usw.). Insbesondere ist zu unterlassen, Kunden, Mitarbeiter oder Berater des Anbieters
          abzuwerben oder abwerben zu versuchen oder sonstige auch außerhalb des gegenständlichen Leistungsangebots gelegene Werbezwecke zu
          verfolgen.
        </p>

        <p>11.3.) Technische Grundlagen:</p>

        <p>
          Für die Bereitstellung und Konfiguration eines Internetanschlusses, von Computern und anderen kommunikationstechnischen Geräten, deren
          Software und/oder Plugins, die benötigt werden, um Zugang zum Online-Unterhaltungsangebot zu erhalten und/oder die Inhalte aufrufen
          bzw. Dienste voll nutzen zu können, ist jeder Kunde selbst verantwortlich.
        </p>

        <p>
          Bei Deaktivierung von im Internet als Standard gebräuchlichen Funktionen wie z.B. Cookies, Java und Javascript sowie bei Verwendung von
          Firewalls sowie Werbe- und Popupkillern kann es zu Problemen bei Nutzung der Mitgliederbereiche kommen! Diese können dadurch behoben
          werden, dass das Mitglied mit den zur Verfügung gestellten Hilfeseiten des Anbieters seine Einstellungen korrigiert.
        </p>

        <p>12. SPERRE UND LÖSCHUNG</p>

        <p>
          Der Anbieter ist ohne vorangegangene Verwarnung zur Sperre eines Mitglieds berechtigt, wenn dieses oder eine dem Mitglied zuzurechnende
          Person (z.B. durch Überlassung der Mitgliedsdaten unter Verletzung von Ziffer 10. dieser AGB Handlungen setzt bzw. verabsäumt, die den
          Anbieter zur fristlosen Kündigung gemäß Ziffer 4 Nr. 6 dieser AGB berechtigen.
        </p>

        <p>
          Der Anbieter behält sich des Weiteren die sofortige Sperre von rechtswidrigen Inhalten eines Mitglieds vor, wenn ihm Tatsachen bekannt
          werden, aus denen die Rechtswidrigkeit offensichtlich zu sein scheint, z.B. wenn Dritte Maßnahmen gegen den Anbieter (bzw. einen seiner
          Dienstleister/Erfüllungsgehilfen) oder den betreffenden Kunden ergreifen oder zu ergreifen drohen und dies mit einer behaupteten
          Rechtswidrigkeit des vom Mitglied stammenden Inhalts begründen.
        </p>

        <p>13. GEWÄHRLEISTUNG UND HAFTUNG DES ANBIETERS</p>

        <p>
          Der Kunde nimmt zustimmend zur Kenntnis, dass das gegenständliche Online-Unterhaltungsangebot hauptsächlich erotischen Inhalts ist. Der
          Anbieter übernimmt weder Gewähr für etwaiges Nichtgefallen des vereinbarungsgemäß bereit gestellten Angebots bzw. einzelner im
          Mitgliederbereich verfügbarer Inhalte, Leistungen und Dienste, noch dafür, dass der Kunde (z.B. in Chats) tatsächlich erfolgreich
          Kontakte mit anderen knüpfen kann.
        </p>

        <p>
          Der Anbieter übernimmt keine Haftung für (von ihm bzw. durch Personen, für die er einzustehen hat - etwa seine Erfüllungsgehilfen -
          rechtswidrig und schuldhaft verursachte) Schäden, soweit es sich nicht um Schäden an der Person bzw. vorsätzlich oder grob fahrlässig
          verursachte Schäden handelt.
        </p>

        <p>14. PFLICHT DES MITGLIEDS ZUR HAFTUNGSFREISTELLUNG</p>

        <p>
          Der Kunde verpflichtet sich, den Anbieter (und dessen Erfüllungsgehilfen) von jeglichen Ansprüchen Dritter oder staatlicher Stellen
          freizuhalten (schad- und klaglos zu halten), welche aufgrund von Daten, Dateien und/oder Inhalten, die das betreffende Mitglied im
          Rahmen des gegenständlichen Online-Unterhaltungsangebots rechtswidrigerweise eingibt, veröffentlicht oder überträgt, erhoben werden.
          Dies gilt sinngemäß auch für alle übrigen Fälle, in denen ein Kunde eine Verletzung von Rechtsvorschriften, Rechten Dritter und/oder
          dieser AGB zu vertreten hat und aufgrund dessen Forderungen/Ansprüche gegen den Anbieter erhoben werden (z.B. verschuldensunabhängiger
          Unterlassungsanspruch eines Dritten gegenüber dem Anbieter wegen Beschimpfungen seitens eines Mitglieds in einem nicht moderierten
          Chat; Verletzung von Urheber- bzw. Leistungsschutzrechten oder Versendung unerbetener Email-Werbung durch ein Mitglied etc.). Dies
          schließt auch eine Ersatzpflicht für angemessene Anwaltskosten ein.
        </p>

        <p>15. LINKS / VERURSACHUNG VON SCHÄDEN DURCH DRITTE</p>

        <p>15.1.)</p>

        <p>
          Der Anbieter überprüft andere Websites nicht hinsichtlich Inhalt und Gesetzmäßigkeit, kann keinen Einfluss auf deren Gestaltung nehmen
          und distanziert sich von dort dargestellten, allenfalls gesetzwidrigen Inhalten. Der Anbieter zeichnet demnach nicht verantwortlich für
          den Inhalt und Politik einer Website, auf die verlinkt wird. Eine Benutzung solcher Links zu Websites Dritter erfolgt auf eigenes
          Risiko.
        </p>

        <p>15.2.)</p>

        <p>
          Der Anbieter schließt ausdrücklich jegliche Verantwortlichkeit und Haftung für das Verhalten Dritter oder von Dritten angebotene oder
          stammende Waren, Dienstleistungen, Werbung oder andere Inhalte, aus - es sei denn, er hätte für diese Personen einzustehen,
          insbesondere weil sie Erfüllungsgehilfen des Anbieters darstellten.(= Personen, deren er sich bedient, um seinen vertraglichen
          Verpflichtungen gegenüber seinen Kunden nachzukommen).
        </p>

        <p>16. Schlussbestimmungen</p>

        <p>
          16.1) Das Vertragsverhältnis unterliegt dem Recht der schweizerischen Eidgenossenschaft unter Ausschluss der schweizerischen
          Kollisionsregelungen des internationalen Privatrechts. Die vorstehende Rechtswahl gilt jedoch nicht, soweit sie Rechte des Nutzers
          einschränken könnte, die nach dem Recht des Staates, in dem der Nutzer seinen gewöhnlichen Aufenthalt hat, nicht durch Vertrag
          eingeschränkt oder ausgeschlossen werden können.
        </p>

        <p>16.2) Soweit gesetzlich zulässig, gilt der Sitz des Anbieters Erfüllungsort und ausschließlicher Gerichtsstand.</p>

        <p>
          16.3) Sollten sich einzelne Bestimmungen dieser allgemeinen Geschäftsbedingungen als unwirksam oder undurchführbar erweisen, so soll
          dies nicht die Wirksamkeit der übrigen Bestimmungen im Übrigen berühren.
        </p>

        <h1 id="privacy_policy">Datenschutzerklärung von ERSTIES</h1>
        <p>
          Nachstehend informieren wir Sie über Art, Umfang und Zweck der Verarbeitung Ihrer personenbezogenen Daten bei der Nutzung unserer
          Webseite und unseres Online-Angebots. Personenbezogene Daten sind alle Informationen, die sich auf eine identifizierte oder
          identifizierbare natürliche Person beziehen.
        </p>
        <p>
          Verantwortlicher im Sinne der EU-Datenschutzgrundverordnung (DSGVO) ist diejenige natürliche oder juristische Person, die allein oder
          gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten entscheidet. Für personenbezogene Daten,
          die der Anbieter dieser Webseite und Onlineservices verarbeitet, ist Verantwortlicher im Sinne der DSGVO:
        </p>
        <p />

        <p>&nbsp;</p>
        <imprint :show-title="false" />
        <p>&nbsp;</p>

        <p><b>Wenn Sie unseren Onlineservice und Webseite verwenden</b></p>
        <p>
          Wenn Sie unsere Webseite besuchen, erhebt unser Server die folgenden Informationen bei Ihnen: Browsertyp und -version, verwendetes
          Betriebssystem, die zuvor besuchte Webseite, IP-Adresse und Zeitpunkt des Seitenaufrufs. Aus Ihrer IP-Adresse können wir nicht auf Ihre
          Person schließen. Wir führen Ihre IP-Adresse auch nicht mit anderen Daten in der Weise zusammen, dass uns ein solcher Rückschluss
          möglich würde.
        </p>
        <p>
          Wir erheben und verarbeiten diese Daten, um den störungsfreien Betrieb unserer Webseite sicherzustellen und einen Missbrauch unserer
          Leistungen erkennen, abwehren und verfolgen zu können. Ferner nutzen wir die erhobenen Daten zu statistischen Zwecken, um etwa
          auszuwerten, mit welchen Endgeräten und Browsern unsere Webseite aufgerufen wird, um auf dieser Basis unser Angebot laufend an die
          Bedürfnisse der Nutzer anzupassen und zu verbessern.
        </p>

        <p v-if="companyStore.isEFC">
          Eine Weitergabe dieser Daten an Dritte findet nicht statt, es sei denn, sie ist zur Verfolgung unserer Ansprüche erforderlich oder es
          besteht eine gesetzliche Verpflichtung gemäß Art. 6 Abs.. 1 c DSGVO oder es sei denn, der Betrieb unserer Website und Ihres
          Kundenkontos wird auf eine andere Betreibergesellschaft übertragen.
        </p>
        <p v-else>Diese Datenverarbeitung erfolgt auf Grundlage von Artikel 6 Absatz 1 Buchstabe f DSGVO.</p>
        <p>Die genannten Daten löschen wir spätestens sechs Monate nach ihrer Erhebung.</p>

        <p>&nbsp;</p>
        <p><b>Kundenkonto</b></p>
        <p>
          Sie können auf unserer Seite ein Kundenkonto anlegen. Die dafür erforderlichen Pflichtangaben werden Ihnen in der Eingabemaske
          mitgeteilt und die eingegebenen Daten werden für die Zwecke der Nutzung des Angebotes verwendet. Wir übermitteln Ihnen angebots- oder
          registrierungsrelevante Informationen, wie Änderungen des Angebotsumfangs oder technische Umstände per E-Mail. Sollten Sie Ihr
          Kundenkonto löschen, werden Ihre Daten aus dem Kundenkonto gelöscht, es sei denn deren Aufbewahrung ist aus handels- oder
          steuerrechtlichen Gründen gem. Absatz 1 Buchstabe c DSGVO notwendig. Es obliegt Ihnen, Ihre Daten vor der Löschung zu sichern. Wir sind
          berechtigt, sämtliche Ihrer während der Vertragsdauer gespeicherten Daten unwiederbringlich zu löschen.
        </p>
        <p>
          Bei der Anmeldung und Nutzung des Kundenkontos, speichern wird die IP-Adresse und den Zeitpunkt Ihrer jeweiligen Nutzungshandlung. Die
          Speicherung erfolgt auf Grundlage unserer berechtigten Interessen, als auch Ihres Interesses an Schutz vor Missbrauch und sonstiger
          unbefugter Nutzung. Eine Weitergabe dieser Daten an Dritte erfolgt grundsätzlich nicht, außer sie ist zur Verfolgung unserer Ansprüche
          erforderlich oder es besteht hierzu eine gesetzliche Verpflichtung gem. Art. 6 Absatz 1 Buchstabe c DSGVO. Die IP-Adressen werden
          spätestens nach 7 Tagen anonymisiert oder gelöscht.
        </p>
        <p>
          Sofern Sie die auf unserer Seite angebotenen kostenpflichten Leistungen in Anspruch nehmen, speichern wir die von Ihnen im Rahmen des
          Bestellvorganges eingegebenen Daten. Dazu gehören insbesondere Ihr Name, Ihre Anschrift, Ihre E-Mail-Adresse, sowie weitere freiwillig
          von Ihnen angegebene Daten (z.B. eine abweichende Lieferadresse oder eine Telefonnummer). Wir verarbeiten diese Daten elektronisch zur
          ordnungsgemäßen Vertragserfüllung, insbesondere für die Erfüllung unser vertraglichen Serviceleistungen, die Rechnungsstellung, die
          Verbuchung von Zahlungen und die Bearbeitung von Reklamationen. Diese Datenverarbeitung erfolgt auf Grundlage von Artikel 6 Absatz 1
          Buchstabe b DSGVO. Wir halten diese Daten gespeichert, bis alle gegenseitigen Ansprüche aus dem jeweiligen Vertragsverhältnis mit Ihnen
          vollständig erledigt und die handels- und steuerrechtlichen Aufbewahrungsfristen abgelaufen sind, denen wir unterliegen.
        </p>
        <p>
          Für einen Vertragsschluss zwischen Ihnen und uns ist es erforderlich, dass wir Ihren Namen, E-Mail-Adresse und Ihre Anschrift erhalten.
          Die Erforderlichkeit der Bereitstellung dieser Daten ergibt sich unter anderem aus gesetzlichen Vorschriften. Ohne Bereitstellung
          dieser Daten können Sie mit uns daher keinen Vertrag schließen.
        </p>
        <p>Wir verzichten auf eine automatisierte Entscheidungsfindung und auf Profiling.</p>

        <p>&nbsp;</p>
        <p><b>Bezahlung</b></p>
        <p>
          Wenn Sie eine über Epoch (Epoch.com, LLC, 2644 30th St FL 2, Santa Monica, California 90405, USA) angebotene Zahlungsmethode nutzen,
          erhebt und verarbeitet Epoch in Ihrem Auftrag Ihren Namen, Ihre Karten- oder Kontonummer und/oder weitere Daten, die für die von Ihnen
          gewählte Zahlungsmethode erforderlich sind. Es gelten insoweit ergänzend die Epoch-Datenschutzbestimmungen
          (https://www.epoch.com/privacy.html).
        </p>

        <p>&nbsp;</p>
        <p><b>Kontaktaufnahme</b></p>
        <p>
          Wenn Sie uns eine Nachricht über die Kontakt-Funktion auf unserer Webseite schicken, übermittelt Sie uns Ihre eingegebenen Daten (Ihren
          Namen und E-Mail-Adresse) zusammen mit Ihrer Nachricht (Rechtsgrundlage: Artikel 6 Absatz 1 Buchstabe a DSGVO). Wenn Sie uns eine
          Nachricht per E-Mail schicken, speichern wir Ihre Nachricht mit den Absenderdaten (Name, E-Mail-Adresse), um sie zu beantworten und
          auch auf eventuelle spätere Folgefragen von Ihnen reagieren zu können (Rechtsgrundlage: Artikel 6 Absatz 1 Buchstabe f DSGVO). Für den
          Empfang, die Speicherung und den Versand von E-Mails nutzen wir einen E-Mail-Anbieter, der für uns als Auftragsverarbeiter im Einklang
          mit Artikel 28 DSGVO tätig wird. Wir löschen die mit Ihrer Nachricht erhobenen Daten spätestens sechs Monate nach der letzten mit Ihnen
          geführten Kommunikation zu Ihrem Anliegen, vorbehaltlich der Reglung im folgenden Absatz.
        </p>
        <p>
          Wenn Sie uns eine rechtlich relevante Erklärung zum Vertragsverhältnis übermitteln (z.B. einen Widerruf oder eine Reklamation), ist
          Rechtsgrundlage für die Verarbeitung, unabhängig vom Übermittlungsweg, auch Artikel 6 Absatz 1 Buchstabe b DSGVO. In einem solchen Fall
          löschen wir die mit Ihrer Erklärung zusammenhängenden Daten, sobald alle wechselseitigen Ansprüche aus dem Vertragsverhältnis endgültig
          erledigt und die handels- und steuerrechtlichen Aufbewahrungsfristen abgelaufen sind.
        </p>

        <p>&nbsp;</p>
        <p><b>Newsletter</b></p>
        <p>
          Nachstehend informieren wir Sie über die Inhalte unseres Newsletters sowie das Anmeldeverfahren und dessen Versand, sowie Ihre
          Widerspruchsrechte. Wenn Sie unseren Newsletter abonnieren, erklären Sie sich mit dem Empfang und dem beschriebenen Verfahren
          einverstanden.
        </p>
        <p>
          Wir versenden Newsletter per E-Mail nur mit Ihrer Einwilligung (Rechtsgrundlage: Art. 6 Abs. 1 lit. a, Art. 7 DSGVO). Vor Anmeldung zu
          dem Newsletter werden Sie zu dessen Inhalten informiert und Ihre Einwilligung bezieht sich nur auf diese Inhalte. Unsere Newsletter
          enthalten Informationen zu unseren Leistungen und uns.
        </p>
        <p>
          Nach Anmeldung zu unserem Newsletter erhalten Sie eine E-Mail, in der Sie um die Bestätigung Ihrer Anmeldung und angegebenen Daten
          gebeten werden. Diese Bestätigungsmail dient uns zur Überprüfung, ob der Inhaber der E-Mail-Adresse als betroffene Person den Empfang
          des Newsletters autorisiert hat. Die Anmeldungen zum Newsletter werden protokolliert, um Ihre Einwilligung und einen rechtmäßigen
          Anmeldeprozess nachweisen zu können. Dazu wird Ihre IP-Adresse im Zeitpunkt des Anmelde- und des Bestätigungszeitpunkts gespeichert
          (Rechtsgrundlage: Art. 6 Abs. 1 lit. a). Für die Anmeldung zum Newsletter benötigen wir Ihre E-Mail-Adresse. Wenn Sie eine persönliche
          Ansprache im Newsletter wünschen, können Sie optional auch Namen angeben.
        </p>
        <p>
          Die Abbestellung des Newsletters – d.h. der Widerruf Ihrer Einwilligung – ist jederzeit möglich. Am Ende einer jeden Newsletter-Email
          finden Sie einen Link zur Abbestellung. Um Ihre ursprüngliche Einwilligung nachweisen zu können, können wir Ihre Anmeldedaten bis zu
          drei Jahren auf Grundlage unserer berechtigten Interessen speichern.
        </p>

        <p>&nbsp;</p>
        <p><b>Social Media</b></p>
        <p>
          Auf unserer Website können Social-Media-Buttons eingeblendet sein; sie sind an den Logos der Social-Media-Plattformen (im Folgenden
          „Plattformen“) zu erkennen (Facebook: blaues „f“, Google Plus: rotes „g+“, Pinterest: rotes „p“, Twitter: blaue Vogel-Silhouette). Es
          handelt sich dabei um Links zu den jeweiligen Plattformen mit Sitz in den USA. Ein Klick auf einen solchen Link ruft die Internetseite
          der jeweiligen Plattform auf, wobei die IP-Adresse des aufrufenden Endgeräts sowie die Adresse der Seite, von der aus verlinkt wird
          („Referrer“), an die aufgerufene Plattform in die USA übermittelt werden. Von uns selbst werden im Zusammenhang mit den
          Social-Media-Buttons jedoch keine Daten erhoben oder verarbeitet.
        </p>

        <p>&nbsp;</p>
        <p><b>Cookies</b></p>
        <p>
          Wir setzen auf unserer Seite Cookies ein. Hierbei handelt es sich um kleine Dateien, die Ihr Browser automatisch erstellt und die auf
          Ihrem Endgerät (Laptop, Tablet, Smartphone o.ä.) gespeichert werden, wenn Sie unsere Seite besuchen.
        </p>
        <p>
          In dem Cookie werden Informationen abgelegt, die sich jeweils im Zusammenhang mit dem spezifisch eingesetzten Endgerät ergeben. Dies
          bedeutet jedoch nicht, dass wir da- durch unmittelbar Kenntnis von Ihrer Identität erhalten.
        </p>
        <p>
          Der Einsatz von Cookies dient einerseits dazu, die Nutzung unseres Angebots für Sie angenehmer zu gestalten. So setzen wir sogenannte
          Session-Cookies ein, um zu erkennen, dass Sie einzelne Seiten unserer Website bereits besucht haben. Diese werden nach Verlassen
          unserer Seite automatisch gelöscht.
        </p>
        <p>
          Darüber hinaus setzen wir ebenfalls zur Optimierung der Benutzerfreundlichkeit temporäre Cookies ein, die für einen bestimmten
          festgelegten Zeitraum auf Ihrem Endgerät ge- speichert werden. Besuchen Sie unsere Seite erneut, um unsere Dienste in Anspruch zu
          nehmen, wird automatisch erkannt, dass Sie bereits bei uns waren und welche Eingaben und Einstellungen sie getätigt haben, um diese
          nicht noch einmal eingeben zu müssen.
        </p>
        <p>
          Zum anderen setzten wir Cookies ein, um die Nutzung unserer Website statistisch zu erfassen und zum Zwecke der Optimierung unseres
          Angebotes für Sie auszuwerten. Diese Cookies ermöglichen es uns, bei einem erneuten Besuch unserer Seite automatisch zu erkennen, dass
          Sie bereits bei uns waren. Diese Cookies werden nach einer jeweils definierten Zeit automatisch gelöscht.
        </p>
        <p>
          Die durch Cookies verarbeiteten Daten sind für die genannten Zwecke zur Wahrung unserer berechtigten Interessen sowie der Dritter nach
          Art. 6 Abs. 1 lit. f DSGVO er- forderlich.
        </p>
        <p>
          Die meisten Browser akzeptieren Cookies automatisch. Sie können Ihren Browser jedoch so konfigurieren, dass keine Cookies auf Ihrem
          Computer gespeichert werden oder stets ein Hinweis erscheint, bevor ein neuer Cookie angelegt wird. Die vollständige Deaktivierung von
          Cookies kann jedoch dazu führen, dass Sie nicht alle Funktionen unserer Website nutzen können.
        </p>

        <p>&nbsp;</p>
        <p><b>Zweckgebundene Datenverwendung und Weitergabe an Dritte</b></p>
        <p>
          Wir beachten den Grundsatz der zweckgebundenen Daten-Verwendung und erheben, verarbeiten und speichern Ihre personenbezogenen Daten nur
          für die Zwecke, für die Sie sie uns mitgeteilt haben. Eine Weitergabe Ihrer persönlichen Daten an Dritte erfolgt ohne Ihre
          ausdrückliche Einwilligung nicht, sofern dies nicht zur Erbringung der Dienstleistung oder zur Vertragsdurchführung notwendig ist. Auch
          die Übermittlung an auskunftsberechtigte staatliche Institution und Behörden erfolgt nur im Rahmen der gesetzlichen Auskunftspflichten
          oder wenn wir durch eine gerichtliche Entscheidung zur Auskunft verpflichtet werden.
        </p>
        <p>Unseren Datenschutzbeauftragten erreichen Sie unter der E-Mailadresse info@ersties.com</p>

        <p>&nbsp;</p>
        <p><b>Übermittlungen in Drittländer</b></p>
        <p>
          Sofern wir Daten in einem Drittland (d.h. außerhalb der Europäischen Union (EU) oder des Europäischen Wirtschaftsraums (EWR))
          verarbeiten oder dies im Rahmen der Inanspruchnahme von Diensten Dritter oder Offenlegung, bzw. Übermittlung von Daten an Dritte
          geschieht, erfolgt dies nur, wenn es zur Erfüllung unserer (vor)vertraglichen Pflichten, auf Grundlage Ihrer Einwilligung, aufgrund
          einer rechtlichen Verpflichtung oder auf Grundlage unserer berechtigten Interessen geschieht. Nur soweit dies gesetzlich oder
          vertraglich erlaubt ist, verarbeiten oder lassen wir Ihre Daten in einem Drittland nur unter den besonderen Voraussetzungen der Art. 44
          ff. DSGVO verarbeiten. Somit erfolgt die Verarbeitung z.B. auf Grundlage besonderer Garantien, wie der offiziell anerkannten
          Feststellung eines der EU entsprechenden Datenschutzniveaus (z.B. für die USA durch das „Privacy Shield“) oder Beachtung rechtlich
          anerkannter Standardvertragsklauseln.
        </p>

        <p>&nbsp;</p>
        <p><b>Mixpanel</b></p>
        <p>
          Im Rahmen der Reichweitenanalyse von Mixpanel werden auf Grundlage unserer berechtigten Interessen (d.h. Interesse an der Analyse,
          Optimierung und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) die folgenden Daten
          verarbeitet: der von Ihnen verwendete Browsertyp und die Browserversion, das von Ihnen verwendete Betriebssystem, Ihr Herkunftsland,
          Datum und Uhrzeit der Serveranfrage, die Anzahl der Besuche, Ihre Verweildauer auf der Website sowie die von Ihnen betätigten externen
          Links. Die IP-Adresse der Nutzer wird anonymisiert, bevor sie gespeichert wird. Mixpanel verwendet Cookies.
        </p>
        <p>
          Mixpanel ist unter dem Privacy-Shield-Abkommen zertifiziert und bietet hierdurch eine Garantie, das europäische Datenschutzrecht
          einzuhalten (https://www.privacyshield.gov/participant?id=a2zt0000000TOacAAG&status=Active).
        </p>
        <p>
          Die durch das Cookie erzeugten Informationen über Ihre Benutzung dieses Onlineangebotes werden auf einem Server in den USA gespeichert.
          Dabei können aus den verarbeiteten Daten Nutzungsprofile der Nutzer erstellt werden, wobei diese nur zu Analyse- und nicht zu
          Werbezwecken eingesetzt werden. Weitere Informationen erhalten Sie in den Datenschutzerklärungen von Mixpanel:
          https://mixpanel.com/legal/privacy-policy/
        </p>

        <p>&nbsp;</p>
        <p><b>Einbindung von Diensten Dritter</b></p>
        <p>
          Wir setzen innerhalb unseres Onlineangebotes auf Grundlage unserer berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung
          und wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6 Abs. 1 lit. f. DSGVO) Inhalts- oder Serviceangebote von
          Drittanbietern ein, um Inhalte und Services, wie z.B. Videos oder Schriftarten einzubinden. Der jeweilige Drittanbieter muss dazu die
          IP-Adresse der Nutzer erhalten, da er ohne die IP-Adresse die Inhalte nicht an den Browser des Nutzers senden kann. Die IP-Adresse ist
          damit für die Darstellung dieser Inhalte erforderlich. Wir bemühen uns nur solche Inhalte zu verwenden, deren jeweilige Anbieter die
          IP-Adresse lediglich zur Auslieferung der Inhalte verwenden.
        </p>

        <p>&nbsp;</p>
        <p><b>Datensicherheit</b></p>
        <p>
          Wir verwenden innerhalb unserer Website das SSL-Verfahren (Secure Socket Layer) in Verbindung mit der jeweils höchsten
          Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird. In der Regel handelt es sich dabei um eine 256 Bit Verschlüsselung. Ob
          einzelne Seiten unseres Webangebotes verschlüsselt übertragen werden ist an der Darstellung eines geschlossenen Schüssel- oder
          Schloss-Symbols in der Statusleiste Ihres Browsers zu erkennen.
        </p>
        <p>
          Wir bedienen uns im Übrigen den geeigneten technischen und organisatorischen Sicherheitsmaßnahmen, um Ihre Daten gegen zufällige oder
          vorsätzliche Manipulationen, teilweisen oder vollständigen Verlust, Zerstörung oder gegen unbefugten Zugriff durch Dritte zu schützen.
          Dabei versuchen wir, unsere Sicherheitsmaßnahmen fortlaufend zu verbessert und technischen Entwicklungen anzupassen.
        </p>

        <p>&nbsp;</p>
        <p><b>Ihre Rechte</b></p>
        <p>Bezüglich der personenbezogenen Daten, die wir über Sie verarbeiten, stehen Ihnen die folgenden Rechte zu:</p>
        <p>
          a) Sie haben das Recht, von uns eine Bestätigung darüber zu verlangen, ob wir Sie betreffende personenbezogene Daten verarbeiten. Ist
          dies der Fall, so teilen wir Ihnen die über Sie gespeicherten personenbezogenen Daten und die weiteren Informationen gemäß Artikel 15
          Abs. 1 u. 2 DSGVO mit.
        </p>
        <p>
          b) Sie haben das Recht, Sie betreffende unrichtige personenbezogene Daten unverzüglich berichtigen zu lassen. Unter Berücksichtigung
          der Zwecke der Verarbeitung haben Sie auch das Recht, die Vervollständigung unvollständiger personenbezogener Daten – auch mittels
          einer ergänzenden Erklärung – zu verlangen.
        </p>
        <p>
          c) Sie können von uns die unverzügliche Löschung der Sie betreffenden personenbezogenen Daten unter den Voraussetzungen von Artikel 17
          Absatz 1 DSGVO verlangen, soweit deren Verarbeitung nicht gemäß Artikel 17 Absatz 3 DSGVO erforderlich ist.
        </p>
        <p>
          d) Sie können von uns die Einschränkung der Verarbeitung Ihrer Daten verlangen, wenn eine der Voraussetzungen von Artikel 18 Absatz 1
          DSGVO vorliegt. Sie können die Einschränkung insbesondere anstelle einer Löschung verlangen.
        </p>
        <p>
          e) Wir werden jede Berichtigung oder Löschung Ihrer personenbezogenen Daten und eine Einschränkung der Verarbeitung allen Empfängern
          mitteilen, denen wir Sie betreffende personenbezogene Daten offengelegt haben, es sei denn, dies erweist sich als unmöglich oder ist
          mit einem unverhältnismäßigen Aufwand verbunden. Wir werden Sie zudem über diese Empfänger unterrichten, wenn Sie dies verlangen.
        </p>
        <p>
          f) Sie haben das Recht, die personenbezogenen Daten, die Sie uns bereitgestellt haben, in einem strukturierten, gängigen und
          maschinenlesbaren Format zu erhalten, und können verlangen, dass wir diese Daten einem anderen Verantwortlichen ohne Behinderung
          übermitteln, soweit dies technisch möglich ist.
        </p>
        <p>
          g) Sie haben das Recht, Ihre Einwilligung jederzeit zu widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der
          Datenverarbeitung, die bis zu Ihrem Widerruf erfolgt ist, nicht berührt. Den Widerruf können Sie formlos an info@ersties.com richten.
        </p>

        <p>&nbsp;</p>
        <p>
          <b
            >WIDERSPRUCHSRECHT: AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN SITUATION ERGEBEN, KÖNNEN SIE JEDERZEIT DER VERARBEITUNG DER SIE
            BETREFFENDEN PERSONENBEZOGENEN DATEN WIDERSPRECHEN; dieses Widerspruchsrecht besteht in Bezug auf diejenige Datenverarbeitung, die
            auf Grundlage von Artikel 6 Absatz 1 Buchstabe f DSGVO zur Wahrung berechtigter Interessen unsererseits oder eines Dritten erfolgt,
            sofern nicht Ihre Interessen oder Grundrechte und Grundfreiheiten, die den Schutz personenbezogener Daten erfordern, überwiegen.
          </b>
        </p>
        <p>
          <b
            >Wenn Sie Ihr Widerspruchsrecht ausüben, werden wir die betreffenden Daten nicht mehr verarbeiten, es sei denn, dass wir zwingende
            schutzwürdige Gründe für die Verarbeitung nachweisen können, die die Interessen, Rechte und Freiheiten von Ihnen überwiegen, oder
            dass die Verarbeitung der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen dient.
          </b>
        </p>

        <p>&nbsp;</p>
        <p>
          <b
            >FÜR DEN FALL, DASS WIR PERSONENBEZOGENE DATEN FÜR DIE DIREKTWERBUNG (Z.B. NEWSLETTER) VERARBEITEN, KÖNNEN SIE JEDERZEIT WIDERSPRUCH
            GEGEN DIE VERARBEITUNG DER SIE BETREFFENDEN PERSONENBEZOGENEN DATEN ZUM ZWECKE DERARTIGER WERBUNG EINLEGEN MIT DER FOLGE, DASS WIR
            IHRE DATEN FÜR DIESE ZWECKE NICHT MEHR VERARBEITEN WERDEN.
          </b>
        </p>

        <p>&nbsp;</p>
        <p>
          Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen die DSGVO verstößt, können Sie Beschwerde einlegen
          bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat Ihres Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des
          mutmaßlichen Verstoßes. Das schließt anderweitige behördliche oder gerichtliche Rechtsbehelfe nicht aus.
        </p>

        <p>&nbsp;</p>
        <p><b>Aktualität und Änderung dieser Datenschutzerklärung</b></p>
        <p>Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Mai 2018.</p>
        <p>
          Durch die Weiterentwicklung unserer Website und Angebote oder aufgrund geänderter gesetzlicher oder behördlicher Vorgaben kann es
          notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils aktuelle Datenschutzerklärung kann jederzeit auf der Website unter
          https://ersties.de/agb#privacy_policy von Ihnen abgerufen und ausgedruckt werden.
        </p>
      </template>
      <!-- eslint-enable vue/no-bare-strings-in-template -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import { useCompanyStore } from "@/store/company";
import { useFeatureStore } from "@/store/feature.ts";
import { useUserStore } from "@/store/user.ts";
import { useI18n } from "vue-i18n";
import Imprint from "@/components/imprint/index.vue";
import { getTld } from "@/utils/urlHelper";
import { changeLanguage } from "@/i18n";
import { FEATURE_AGE_VERIFICATION } from "@/utils/variables.ts";

defineOptions({
  name: "terms-and-conditions",
});

const route = useRoute();
const companyStore = useCompanyStore();
const featureStore = useFeatureStore();
const userStore = useUserStore();
const { locale } = useI18n();

const tld = getTld();

const showAgeVerificationText = computed(() => featureStore.getFeature(FEATURE_AGE_VERIFICATION, !userStore.isLoggedIn) !== null);

async function checkNotice() {
  const hash = route.hash ? route.hash.substring(1) : "";

  if (companyStore.isEFC && hash === "notice" && locale.value === "de") {
    await changeLanguage("en");
  }
}

watch(route, checkNotice);

onMounted(async () => {
  await checkNotice();

  const hash = route.hash ? route.hash.substring(1) : "";
  const el = hash ? document.getElementById(hash) : null;

  if (!el) {
    return;
  }

  setTimeout(() => {
    window.scroll({
      top: el.offsetTop,
      behavior: "smooth",
    });
  }, 100);
});

companyStore.defineCompany(false);
</script>

<style lang="scss">
@import "./index";
</style>
